import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@material-ui/core';
import moment from 'moment';
import { decode } from 'base-64';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import Loader from '../../StaticComponent/Loader';
// import Loader from './Loader';

import Loader from '../StaticComponent/Loader';
import Select from 'react-select';
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { MultiSelect } from "react-multi-select-component";
import { getS3 } from '../utils/Download.js';

import { Space } from 'antd';

import { encryptStorage } from '../constant';
import {
    getAllCandidate,
    getExperienceCandidate,
    getFresherCandidate,
    getJobsInformation,
    getInterviewRound,

    // reused
    postInterview,
    insertHoldCandidate,
    updateFresherStatus,
    updateExpStatus,
    postFresherInterchange,
    postExpInterchange,
    getCandidateSearchData,
    getCandidateFilterData,
    postExpInterview,
    postExpBulkInterview,
    postBulkInterview,
    sendMail,
    directory,
    updateInterview,
    updateExpInterview,
    getFresherSearchData,
    getExpSearchData,
    postStages,
    postHireStage,
    freshercolorfeedback,
    expColorFeedback,
    getScheduledInterview,
    getFresherCandidateFilterData,
    getExpCandidateFilterData,
    getFresherSort,
    getExpSort,
    getCount,
    getJobsData,
    overallColorFeedback,
    getTeamsInvite,
    getJob,
    getLoginEmailId,
    getBatchDetails,
    sendMailCandidate,
    insertBulkInterviewData,
    postTimeline,
    getLogin1,
    getInterviewers,
} from '../service/RecruiterApi';
import EvaluationPopUp from './EvaluationPopUp';
import CandidatePopupGrid from './CandidatePopupGrid'
export function RecruitmentComponent(props) {

    let path = window.location.pathname;
    //PC_RC_2 declaring state variables
    const [gridData, setGridData] = useState([]);
    const [gridDataStatus, setGridDataStatus] = useState([]);
    // const [CandidateCount, setCandidateCount] = useState('');
    //PC_RC_3 useRef for search
    const searchRef = useRef();
    const [SearchData, setSearchData] = useState('');
    //PC_RC_4 state variable for filter
    const filterObj = {
        status: '',
        college_name: [],
        // stage: '',
        offerletter_status: '',
        jobId: '',
        batch_no: '',
        fromDate: '',
        toDate: '',
        scheduled_by: '',
        //experience: '',
        interview_source_id: '',
        job_source_name: '',
        stages: '',
        interview_round_name: '',


    };
    const [FilterData, setFilterData] = useState(filterObj)
    //PC_RC_5 state variable for sort
    const sortObj = {
        column_name: 'id',
        order_type: 'desc',
    };

    const [SortData, setSortData] = useState(sortObj);
    //PC_RC_6 state variable for pagination
    const [CurrentPage, setCurrentPage] = useState(0);
    let totalPage = gridData.length;
    //PC_RC_7 state variable for radio buttons
    const [isReschedule, setIsReschedule] = useState(false);
    const [SelectedRadio, setSelectedRadio] = useState({ stage: 'Screening', interview_round_id: '', interview_round_name: '' });
    const [FinalRound, setFinalRound] = useState(0);
    const [isLoading, setIsLoading] = React.useState(true);
    const [interviewDD, setInterviewDD] = useState([]);
    const [interviewSourceDD, setInterviewSourceDD] = useState([]);

    const [jobsDD, setJobsDD] = useState([]);
    const [collegeDropdown, setCollegeDropdown] = useState([]);
    const [fresherInterviewerDD, setFresherInterviewerDD] = useState([]);
    const [expInterviewerDD, setExpInterviewerDD] = useState([]);
    let [nextPage, setNextPage] = useState(0);
    const [filterShow, setFilterShow] = useState(false)
    const Refer = useRef();
    const Search = window.location.search;
    let job_Id = new URLSearchParams(Search).get('id');
    let role = props.role;
    const exp = props.exp;
    const [insertToast, setinsertToast] = useState(false);
    const [roundHidden,setRoundHidden]=useState(true)
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    const [interviewRound, setInterviewRound] = useState();
    const [candidateName, setCandidateName] = useState('');
    const [isLoadingLoader, setIsLoadingLoader] = useState(true);
    const [interviewersDD, setInterviewersDD] = useState([]);
    const [showContainer, setShowContainer] = useState(false);
    const [selectedInterviewRound, setSelectedInterviewRound] = useState('');

    //PC_BI_01 -> state variables are declared and assigned to respective values
    const [timeIntervalValidations, setTimeIntervalValidations] = useState('');
    const [intervalHidden, setIntervalHidden] = useState(true);
    const [popUp, setPopUp] = useState('');
    const [confirmationContainer, setConfirmationContainer] = useState(true);
    let [batchNo, setBatchNo] = useState('');
    let [showPopup, setShowPopup] = useState(false);
    const [candidateRecords, setCandidateRecords] = useState([]);
    let [popupCheckArray, setPopupCheckArray] = useState([]);

    let date = new Date();
    let dates = moment(date).format('YYYY-MM-DD');
    const [selectedRecords, setSelectedRecords] = useState([]);


    // reused state variables and objects

    //PC_HC_2
    /**
     * PS_SC_02 - Declare useState hooks for hideSortIcon and gridData, and define sortIcon object
     */
    let sortIcon = {
        first_name: 'desc',
        id: 'desc',
        job_id: 'desc',
        job_title: 'desc',
        status: 'desc',
        offerletter_status: 'desc',
        //experience: 'desc',
        created_at: 'desc',
        interview_round_name: 'desc',
        job_source_name: 'desc'
    };

    let holdCandidateObj = {
        candidate_id: '',
        job_id: 6,
        email: '',
        reason_for_hold: '',
    };
    let holdCandidateErrorObj = {
        email: '',
        reason_for_hold: '',
    };
    let interchangeErrData = {
        job_title: '',
    };

    let scheduleObj = {
        candidate_id: [],
        job_id: job_Id || '',
        title: '',
        meeting_details: '',
        interview_round_id: '',
        interview_date: '',
        start_time: [],
        end_time: [],
        local_start_time: '',
        local_end_time: '',
        // interviewers: [UserId],
        candidates: [],
        scheduled_by: '',
        interview_round_name: '',
        time_interval: '',
        schedule: 'Schedule',
        availability: true,
        availabilityStatus: 'Available',
        comments: '',
    };

    let [hideSortIcon, setHideSortIcon] = useState(sortIcon);
    // let [gridData, setGridData] = useState([]);
    let [gridDataCount, setGridDataCount] = useState();
    const [gridColorData, setGridColorData] = useState([]);
    const [submitInterviewMode, setSubmitInterviewMode] = useState('Insert');
    let [holdData, setHoldData] = useState(holdCandidateObj);

    let [scheduleData, setScheduleData] = useState(scheduleObj);

    const [showEmployee, setShowEmployee] = useState();
    const [emp, setEmp] = useState();
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    let [empId, setEmpId] = useState([]);
    let [holdErrData, setHoldErrData] = useState(holdCandidateErrorObj);
    let [interchangeErrorData, setinterchangeErrData] = useState(interchangeErrData);
    const [columnName, setColumnName] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [columnSearch, setColumnSearch] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [holdflag, setholdflag] = useState(true);
    const [unholdflag, setunholdflag] = useState(false);
    const [blockflag, setblockflag] = useState(true);
    const [unblockflag, setunblockflag] = useState(false);
    const [numberOfRows, setNumberOfRows] = useState(10);
    const [flag, setFlag] = useState(true);
    const [CandidateGrid, setCandidateGrid] = useState('');

    // schedule Interview Validation
    const [interviewData, setInterviewData] = useState({
        ...scheduleObj,
        availabilityStatus: 'Available'
    });
    const [selectedCandidate, setSelectedCandidate] = useState([]);
    let [showCandidate, setShowCandidate] = useState([]);
    // const [scheduledInterviewData, setScheduledInterviewData] = useState({
    //   Name: "",
    //   position: "",
    //   stage: "",
    //   scheduled: "",
    //   date: "",
    //   duration: ""
    // });

    let [titleValidation, setTitleValidation] = useState('');
    let [meetingDetailsValidation, setMeetingDetailsValidation] = useState('');
    let [interviewRoundValidation, setInterviewRoundValidation] = useState('');
    let [interviewerValidation, setInterviewersValidation] = useState('');
    let [candidatesValidation, setCandidatesValidation] = useState('');
    let [dateValidation, setDateValidation] = useState('');
    let [startTimeValidation, setStartTimeValidation] = useState('');
    let [endTimeValidation, setEndTimeValidation] = useState('');

    let [hideBar, setHideBar] = useState(true);
    let [hideCandidate, setHideCandidate] = useState(true);
    let [hideSchedule, setHideSchedule] = useState(true);
    let [hideHold, setHideHold] = useState(true);
    let [hideInterchange, setHideInterchange] = useState(true);
    let [actionBarGenerateOffer, setActionBarGenerateOffer] = useState(true);
    let [checkBoxCount, setCheckBoxCount] = useState(0);
    let [renderFlag, setRenderFlag] = useState(true);
    let [interchangeData, setInterchangeData] = useState({
        job_id: '',
        job_title: '',
        checked: false,
    });

    let [loadmore, setLoadmore] = useState(0);
    let [allCheck, setallCheck] = useState(false);
    let [loadMoreCheck, setloadMoreCheck] = useState('');
    let [filterCheck, setfilterCheck] = useState('');
    let [searchCheck, setsearchCheck] = useState('');
    const recruitRole = encryptStorage.getItem('recruitRole');
    let [filterOffset, setFilterOffset] = useState(0);
    let [searchOffset, setsearchOffset] = useState(0);
    const [jobTitle, setJobTitle] = useState();
    let UserName = encryptStorage.getItem('username');
    let UserId = encryptStorage.getItem('employeeId');
    let [arrStatusStore, setArrStatusStore] = useState([])

  

    let bind = async () => {
        let empResult = [];

        empResult = await directory({});

        let loginEmail = await getLoginEmailId({ emp_id: encryptStorage.getItem('employeeId') });

        let email = loginEmail.data.data[0].email_id;

        let samplearray = [];

        let temparray = empResult?.data?.ResponseData?.emplist;

        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,

                email_id: temparray[i].email_id,

                img: '/Images/logo-person-user-person-icon.jpg',

                label: temparray[i].emp_name,

                username: temparray[i].emp_name,
            };

            samplearray.push(objresponse);
        }

        setShowEmployee(samplearray);

        let objresponse = {
            value: UserId,

            img: '/Images/logo-person-user-person-icon.jpg',

            label: UserName,

            username: UserName,

            email_id: email,
        };

        setShowEmployee(samplearray);

        let arr = [];

        arr.push(objresponse);

        setSelectedPeopleList(arr);

        let newObj = {
            value: props.candidate_id,

            label: props.email,

            username: props.email,
        };

        setSelectedCandidate(newObj);

        empResult?.push(newObj);

        setShowCandidate(empResult);
    };

    useEffect(() => {
        getDropdown();
        bind();
        if (path == '/Recruitment/Jobs') {
            //PC_RC_13 call the function to fetch the candidate against job
            loadCandidate();
        }
        //PC_RC_14 call the function to fetch overall grid
        else {
            loadGrid();

        }

        // loadInterviews("Group Discussion");
        loadData();

        // bindInterview()
    }, [SelectedRadio, SearchData, SortData, CurrentPage, renderFlag]); //PC_RC_12
    const [commentsValidation, setCommentsValidation] = useState('')
    const schedule = async () => {
        try {
            setallCheck(false);
            setEmpId([]);
            if (interviewData.availabilityStatus === 'Available') {
                // Handling for Available candidates
                let start = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interviewData.local_start_time}.2444915-07:00`;
                let end = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interviewData.local_end_time}.2444915-07:00`;

                if (validation(start, end)) {
                    setConfirmationContainer(false);
                    // setPopUp('Schedule Interview');
                    if (isReschedule) {
                        // Show reschedule confirmation instead
                        setPopUp('Reschedule Interview');
                    } else {
                        // Proceed with scheduling confirmation if not a reschedule
                        setPopUp('Schedule Interview');
                    }
                }
            }
            else if (interviewData.availabilityStatus === 'Not Available') {
                // Handling for Not Available candidates
                if (validateNotAvailable()) {
                    setConfirmationContainer(false);
                    setPopUp('Mark as Not Available');
                }
            }
        } catch (e) {
            console.error('Error in scheduling:', e);
            // Handle the error appropriately (e.g., show an error message to the user)
        }
    }

    // Add this new validation function for "Not Available" scenario
    const validateNotAvailable = () => {
        if (!interviewData.interview_round_id) {
            setInterviewRoundValidation('Please select an interview round');
            return false;
        }
        if (!interviewData.comments.trim()) {
            // Assuming you have a state for comments validation
            setCommentsValidation('Please provide a reason for unavailability');
            return false;
        }
        return true;
    };

    let loadData = async () => {
        try {
            // setIsLoadingLoader(false);
            let res = await getInterviewers({ job_id: job_Id });
            setInterviewersDD(res.data.data);

            let val = await getJob({ job_id: job_Id });

            setJobTitle(val.data.data[0].job_title);
            // setRecommendationDD(resp.data.data[1]);
            // bind();
        } catch (e) {
            throw e;
        }
    };
    //PC_RC_15 candidate against job function gets triggered
    let loadCandidate = async (clear) => {
        try {
            //PC_RC_16 try block
            setIsLoadingLoader(false);

            let response;
            let resp = await getJobsInformation({ jobID: job_Id }); //PC_RC_17 call the function to fetch job information

            var values = resp.data.data[0]; //PC_RC_18 store the response
            
            setJobTitle(values.job_title);
            if (values.hasOwnProperty('description')) {
                delete values['description'];
            }
            let obj = {
                SelectedRadio: SelectedRadio,
                SearchData: SearchData,
                SortData: SortData,
                FilterData: FilterData,
                CurrentPage: CurrentPage,
                values: values,
                job_Id: job_Id,
            };
            if (clear == 'clear') {
                obj = {
                    SelectedRadio: SelectedRadio,
                    SearchData: SearchData,
                    SortData: SortData,
                    FilterData: filterObj,
                    CurrentPage: CurrentPage,
                    values: values,
                    job_Id: job_Id,
                };
            }

            if (values.experience == 'Fresher') {
                //PC_RC_19 check the condition for fresher or experienced candidate
                setIsLoading(false);
                //PS_BC_04-05
                response = await getFresherCandidate(obj); //PC_RC_20 call the fresher function to get fresher candidate details
                setIsLoading(true); //PC_RC_33 setstate to true
                //PC_RC_34 setstate GridData with the response
                if (CurrentPage == 0) {
                    
                    //PS_BC_15
                    setGridData(response.data.data);
                }
                if (CurrentPage == 0) {
                    setGridData(response.data.data);
                }
                else {
                    
                    setGridData(prevData => [...prevData, ...response.data.data]);}
               


                setGridDataStatus(response.data.feedbackResult1);
                setArrStatusStore(prevData => [...prevData, ...response.data.feedbackResult1]);

                //PS_BC_16
                setGridDataCount(response.data.count[0]?.count);
                setIsLoadingLoader(true);
            } else {
                setIsLoading(false); //PC_RC_37 setstate to false
                response = await getFresherCandidate(obj); //PC_RC_38 call the experienced function to get experienced candidate details
              
                setIsLoading(true); //PC_RC_50 setstate to true
                //PC_RC_51 setstate the GridData with the response
                if (CurrentPage == 0) {
                    setGridData(response.data.data);
                if (CurrentPage == 0) {
                    setGridData(response.data.data);
                }
                else {
                    setGridData([...gridData, ...response.data.data]);
                }
            

                setGridDataStatus(response.data.feedbackResult1);
                setGridDataCount(response.data.count[0]?.count);
                setIsLoadingLoader(true);}}
            
        } catch (e) {
            throw e;
        }
    };
    /**
     * 
     * PS_SC_06 - PS_SC_12 - call getAllCandidate to get a grid data from backend and store the value in setGridData
     * PS_SC_21 - PS_SC_27 - For sorting also this same getAllCandidate will be call
     */
    let loadGrid = async (sortvalue) => {
        try {
            setIsLoading(false);
            let response = await getAllCandidate({
                offset: nextPage,
                sort: sortvalue,
            });
            setIsLoading(true);

            setGridData(response.data.data);

            //gridData = [].concat(...response.data.data);
            // setGridData(response.data.data);
            let response1 = await getCount({
                sort: sortvalue,
            });

            setGridDataCount(response1.data.data[0].count);

            let candidateIDArray = [];
            for (let i = 0; i < response.data.data.length; i++) {
                candidateIDArray.push(response.data.data[i].id);
            }

            let colorfeedback = await overallColorFeedback({
                job_id: job_Id,
                candidate_id: candidateIDArray,
            });
            let colorarray = [];

            for (let j = 0; j < colorfeedback.data.data.length; j++) {
                colorarray.push(colorfeedback.data.data[j].recommendation);

                //gridColorData = [].concat(...colorfeedback.data.data[j].recommendation);
                setGridColorData([...gridColorData, ...colorarray]);
            }

            setFlag(!flag);
        } catch (e) {
            throw e;
        }
    };
    /**
     * PS_02 - PS_03 -- getDropdown function is triggered 
     */
    let getDropdown = async () => {
        let data = {
            job_id: job_Id,
        };
        let ddResp = await getInterviewRound(data);
        // let dpresp = await getCandidateFilterData(data);
        if (ddResp) {
            setInterviewDD(ddResp?.data?.data[0]);
            setInterviewSourceDD(ddResp?.data?.data[1]);
            setJobsDD(ddResp?.data?.data[2]);
            setFresherInterviewerDD(ddResp?.data?.data[3]);
            setExpInterviewerDD(ddResp?.data?.data[4]);

            if (ddResp.data.data[5]) {
                setCollegeDropdown(ddResp.data.data[5]);
            }
        

    };}
    
    let checkboxArray=[];
    const [checkArray, setCheckArray] = useState(checkboxArray);
    const [availabilityStatusValidation, setAvailabilityStatusValidation] = useState('');
    let validation = (start, end) => {
         checkboxArray = new Array(gridData?.length).fill(false);
  
        let result = true;
        let checkregex = OnlyNumberSpecialChar(interviewData.title);
        if (interviewData.title == '') {
            setTitleValidation('Title is required');
        } else if (interviewData.title != '' && checkregex) {
            setTitleValidation('Valid Title is required');
            result = false;
        } else {
            setTitleValidation('');
        }

        if (interviewData.interview_round_name !== 'Group Discussion') {
            if (interviewData.time_interval === '') {
                setTimeIntervalValidations('Time Interval is required');
                result = false;
            } else {
                let diff = timeDiff(interviewData.local_start_time, interviewData.local_end_time);
                let timeDiffr = diff / checkBoxCount;
                if (timeDiffr != interviewData.time_interval) {
                    setTimeIntervalValidations('Selected Time Interval does not match the chosen duration');
                    result = false;
                } else {
                    setTimeIntervalValidations('');
                }
            }
        }
        // if (interviewData.meeting_details == '') {
        //     setMeetingDetailsValidation('Meeting Details is required');
        // }
        if (interviewData.interview_round_id == '') {
            setInterviewRoundValidation('Interview round is required');
            result = false;
        }
        else {
     
            setInterviewRoundValidation('')
        }
        if (interviewData.interview_date == '') {
            setDateValidation('Interview date  is required');
        }
        if (interviewData.start_time == '') {
            setStartTimeValidation('Start Time is required');
        }
        if (interviewData.end_time == '') {
            setEndTimeValidation('End Time is required');
        } else if (end < start) {
            setEndTimeValidation('Valid End time is required');
        }
        //PC_BI_16 -> Selected time Interval is checked for validations
        let diff, timeDiffr;
        if (SelectedRadio.stage !== 'Screening' && roundHidden==true) {
            if (interviewData.time_interval == '') {
                setTimeIntervalValidations('Time Interval is required');
            }

            diff = timeDiff(interviewData.start_time, interviewData.end_time);
            timeDiffr = diff / checkBoxCount;
            if (interviewData.time_interval == '') {
            if (interviewData.time_interval == '') {
                setTimeIntervalValidations('Time Interval is required');
            }
            else if (timeDiffr != interviewData.time_interval) {

                setTimeIntervalValidations('Selected Time Interval does not match the chosen duration');
            } else {
                setTimeIntervalValidations('');
            }
        }
    }
        if (selectedPeopleList.length == 0) {
            setInterviewersValidation('Interviewers is required');
            result = false;
        } else {
            setInterviewersValidation('');
        }
        let date = new Date();

        let dates = moment(date).format('YYYY-MM-DD');

        if (interviewData.interview_date == dates) {
            let currentTime = new Date().toLocaleTimeString();
            let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

            if (interviewData.local_start_time < convertedTime) {
                setStartTimeValidation('Valid Start Time is required');
            } else {
                setStartTimeValidation('');
            }
        }
        if (interviewData.interview_date == dates) {
            let currentTime = new Date().toLocaleTimeString();
            let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

            if (interviewData.local_end_time < convertedTime) {
                setEndTimeValidation('Valid End Time is required');
            } else {
                setEndTimeValidation('');
            }
        }

        // let check = OnlyNumberSpecialChar(interviewData.meeting_details);
        // if (check) {
        //     setMeetingDetailsValidation('Valid Meeting Details is required');
        //     result = false;
        // } else {
        //     setMeetingDetailsValidation('');
        // }
        if (SelectedRadio.stage !== 'Screening' && SelectedRadio.interview_round_name !== 'Group Discussion') {
            if (
                interviewData.title != '' &&
                interviewData.interview_date != '' &&
                interviewData.start_time != '' &&
                interviewData.end_time != '' &&
                start < end &&
                selectedPeopleList.length !== 0 &&
                timeDiffr == interviewData.time_interval
            ) {
                if (interviewData.interview_date == dates) {
                    let currentTime = new Date().toLocaleTimeString();
                    let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                    if (interviewData.local_start_time < convertedTime) {
                        setStartTimeValidation('Valid Start Time is required');
                        result = false;
                    } else {
                        setStartTimeValidation('');
                    }
                }
                if (interviewData.interview_date == dates) {
                    let currentTime = new Date().toLocaleTimeString();
                    let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                    if (interviewData.local_end_time < convertedTime) {
                        setEndTimeValidation('Valid End Time is required');
                        result = false;
                    } else {
                        setEndTimeValidation('');
                    }
                }

                let checkregex = OnlyNumberSpecialChar(interviewData.title);
                if (checkregex) {
                    setTitleValidation('Valid Title is required');
                    result = false;
                } else {
                    setTitleValidation('');
                }

                // let check = OnlyNumberSpecialChar(interviewData.meeting_details);
                // if (checkregex) {
                //     setMeetingDetailsValidation('Valid Meeting Details is required');
                //     result = false;
                // } else {
                //     setMeetingDetailsValidation('');
                // }
            } else {
                result = false;
            }
        }
        if (SelectedRadio.stage == 'Screening') {
            if (
                interviewData.title != '' &&
                interviewData.interview_date != '' &&
                interviewData.start_time != '' &&
                interviewData.end_time != '' &&
                start < end &&
                selectedPeopleList.length !== 0
            ) {
                if (interviewData.interview_date == dates) {
                    let currentTime = new Date().toLocaleTimeString();
                    let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                    if (interviewData.local_start_time < convertedTime) {
                        setStartTimeValidation('Valid Start Time is required');
                        result = false;
                    } else {
                        setStartTimeValidation('');
                    }
                }
                if (interviewData.interview_date == dates) {
                    let currentTime = new Date().toLocaleTimeString();
                    let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                    if (interviewData.local_end_time < convertedTime) {
                        setEndTimeValidation('Valid End Time is required');
                        result = false;
                    } else {
                        setEndTimeValidation('');
                    }
                }

                let checkregex = OnlyNumberSpecialChar(interviewData.title);
                if (checkregex) {
                    setTitleValidation('Valid Title is required');
                    result = false;
                } else {
                    setTitleValidation('');
                }

                // let check = OnlyNumberSpecialChar(interviewData.meeting_details);
                // if (checkregex) {
                //     setMeetingDetailsValidation('Valid Meeting Details is required');
                //     result = false;
                // } else {
                //     setMeetingDetailsValidation('');
                // }
            } else {
                result = false;
            }
        }

        return result;
    }

    //loadInterviews is called
    let loadInterviews = async () => {
        
        try {
            //
            let data = { job_id: job_Id };
            let resp = await getInterviewRound(data);

            for (let i = 0; i < resp.data.data[0].length; i++) {

                if (resp.data.data[0][i].interview_round_name == 'Group Discussion') {
                    setInterviewData({
                        ...interviewData,
                        interview_round_id: resp.data.data[0][i].id,
                        interview_round_name: resp.data.data[0][i].interview_round_name,
                    });
                }
            }

            // setInterviewRoundDD(arr);
        } catch (e) { }
        
    };
    
    const handleCollegeChange = (event) => {
        const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
        setFilterData(prevState => ({
            ...prevState,
            college_name: [...new Set([...prevState.college_name, ...selectedOptions])]
        }));
    };

    const handleRemoveCollege = (collegeToRemove) => {
        setFilterData(prevState => ({
            ...prevState,
            college_name: prevState.college_name.filter(college => college !== collegeToRemove)
        }));
    };
    //RADIO BIND
    //PC_BI_4 binding the radio options dynamically on pageload
    let bindInterview = () => {
        try {
            return interviewDD?.map((value, index) => {
                //PC_BI_5 map the interviewDD value

                const interviewName = value.interview_round_name
                    .split(' ')
                    .map((word) => word[0])
                    .join('');

                return (
                    <>
                        <div class="form-check d-inlineblock me-3">
                            <input
                                style={{ marginRight: '10px' }}
                                className="form-check-input custom-radio-btn"
                                type="radio"
                                id={index}
                                value={value.id}
                                name="interview-round"
                                hidden={value.interview_round_name == ''}
                                key={index}
                                onClick={(e) => {
                                    setInterviewRound(value.interview_round_name);
                                    setSelectedRadio({
                                        ...SelectedRadio,
                                        interview_round_id: e.target.value,
                                        interview_round_name: value.interview_round_name,
                                        stage: '',

                                    });
                                    setFinalRound(interviewDD[interviewDD.length - 1].id);
                                    setHideBar(true);
                                    setCandidateRecords([])
                                    setShowCandidate([]);
                                    setEmpId([]);
                                    let checkboxArray = new Array(gridData?.length).fill(false);
                                    setCheckArray(checkboxArray);
                                    setallCheck(false);
                                    setFilterData(filterObj);
                                    setCurrentPage(0)
                                }}
                            />
                            <label
                                style={{ marginRight: '15px' }}
                                for={index}
                                class="form-check-label regular-text font-12 personal-text-blue"
                            >
                                {interviewName}
                            </label>
                        </div>
                    </>
                );
            });
        } catch (e) {
            throw e;
        }
    };



    // const bindCollege = () => {
    //     return collegeDropdown.map((college) => (
    //         <option key={college.id} value={college.college_abbreviation}>
    //             {college.college_abbreviation}
    //         </option>
    //     ));
    // };

    // let bindCollege = () => {
    //     try {
    //         //
    //         return collegeDropdown?.map((college) => {
    //             return (
    //                 <option key={college.id} value={college.college_abbreviation}>
    //                     {college.college_abbreviation}
    //                 </option>
    //             );
    //         });
    //     } catch (e) { }
    // };
    let bindCollege = () => {
        try {
            return collegeDropdown?.map((college) => ({
                value: college.college_abbreviation,
                label: college.college_abbreviation
            }));
        } catch (e) { }
    };
    //DROP DOWN BIND

    let bindJobPosition = () => {
        try {
            //
            return jobsDD?.map((obj, index) => {
                return (
                    <option key={index} value={obj.id}>
                        {obj.job_title}
                    </option>
                );
            });
        } catch (e) { }
    };

    let bindJobsTitles = () => {
        try {
            return jobsDD?.map((obj, index) => {
                return (
                    <option hidden={obj.experience != exp} key={index} value={obj.id + '@' + obj.job_title}>
                        {obj.job_title}
                    </option>
                );
            });
        } catch (e) { }
    };

    // let bindExperience = () => { //PC_FD_22
    //     try {
    //         //PC_FD_23
    //         return jobsDD.map((obj, index) => {
    //             return (
    //                 <option key={index} value={obj.id}>{obj.experience}</option>
    //             );
    //         });
    //     }
    //     catch (e) {
    //         throw e;
    //     }
    // }

    // function bindFresherBatch() {

    //     try {
    //         
    //       if (!fresherInterviewerDD || !fresherInterviewerDD.batch_no) {
    //         return null; // or handle the case where fresherInterviewerDD or batch_no is undefined
    //       }

    //       const uniqueBatchNumbers = [...new Set(fresherInterviewerDD.map(item => item.batch_no))];


    //       return uniqueBatchNumbers.map((batchNumber, index) => (
    //         <option key={index} value={batchNumber}>
    //           Batch {batchNumber}
    //         </option>
    //       ));
    //     } catch (e) {
    //       throw e;
    //     }
    //   }

    function bindFresherBatch() {
        try {
            let batch = [];

            fresherInterviewerDD?.map((value, index) => {
                
                if (job_Id == value.job_id) {
                   

                    if (value.batch_no == null) {
                        // batch.push(''); // or handle the case where fresherInterviewerDD or batch_no is undefined
                    } else {
                        batch.push(value.batch_no);
                        
                    }
                }
            });
            let uniqueBatch = [...new Set(batch)];
            return uniqueBatch?.map((value, index) => {
                return (
                    <option key={index} value={value}>
                        Batch {value}
                    </option>
                );
            });
        } catch (e) {
            throw e;
        }
    }

    function bindExpBatch() {
        try {
            let batch = [];

            expInterviewerDD?.map((value, index) => {
                if (job_Id == value.job_id) {
                    if (value.batch_no == null) {
                        batch.push(''); // or handle the case where fresherInterviewerDD or batch_no is undefined
                    } else {
                        batch.push(value.batch_no);
                    }
                }
            });
            let uniqueBatch = [...new Set(batch)];
            return uniqueBatch?.map((value, index) => {
                return (
                    <option key={index} value={value}>
                        Batch {value}
                    </option>
                );
            });
        } catch (e) {
            throw e;
        }
    }

    // function bindFresherInterviewer() {
    //     try {
    //         
    //         let interviewerName=[]

    //         fresherInterviewerDD?.map((value, index) => {
    //             if(job_Id==value.job_id){
    //             if (value.scheduled_by==null ) {
    //                 interviewerName.push(""); // or handle the case where fresherInterviewerDD or interviewername is undefined
    //              }
    //              else{
    //             interviewerName.push(value.scheduled_by)
    //              }
    //             }
    //         });
    //         let uniqueInterviewer=[...new Set(interviewerName)];
    //         // return uniqueInterviewer.map((value, index) => {
    //         //     let parsedValue=json.parse(value)

    //         //                 return (
    //         //                     <option key={index} value={value}>
    //         //                         {parsedValue}
    //         //                     </option>
    //         //                 );
    //         //             });

    //     } catch (e) {
    //         throw e;
    //     }
    // };

    function bindFresherInterviewer() {
        try {
            ;
            let interviewerName = [];

            fresherInterviewerDD?.map((value, index) => {
                if (job_Id == value.job_id) {
                    if (value.scheduled_by == null) {
                        interviewerName.push(null); // or handle the case where fresherInterviewerDD or interviewername is undefined
                    } else {
                        interviewerName.push(value.scheduled_by);
                    }
                }
            });

            let uniqueInterviewer = [...new Set(interviewerName)];

            let array = [];

            uniqueInterviewer.forEach((value, index) => {
                let parsedData;
                if (value && typeof value === 'string' && value.trim() !== '' && !/^\s*'\s*'\s*$/.test(value)) {
                    parsedData = JSON.parse(value)
                } else {
                    parsedData = value;
                }

                // if (parsedData && typeof parsedData === 'object') {
                const keys = Object.values(parsedData);
                if (keys.length == 1) {
                    array.push(keys[0]);
                } else {
                    keys.forEach((keyValue) => {
                        array.push(keyValue);
                    });
                }
                // } 
            });
            array = [...new Set(array)];


            return array?.map((value, index) => {

                return (
                    <option key={index} value={value}>
                        {value}
                    </option>
                );
            });
        } catch (e) {
            throw e;
        }
    }

    function bindExpInterviewer() {
        try {

            let interviewerName = [];

            expInterviewerDD?.map((value, index) => {
                if (job_Id == value.job_id) {
                    if (value.scheduled_by == null) {
                        interviewerName.push(''); // or handle the case where expInterviewerDD or interviewername is undefined
                    } else {
                        interviewerName.push(value.scheduled_by);
                    }
                }
            });

            let uniqueInterviewer = [...new Set(interviewerName)];

            let array = [];


            uniqueInterviewer.forEach((value, index) => {
                let parsedData;
                if (value && typeof value === 'string' && value.trim() !== '' && !/^\s*'\s*'\s*$/.test(value)) {
                    parsedData = JSON.parse(value);
                } else {
                    parsedData = value; // or some default value, depending on your use case
                }
                const keys = Object.values(parsedData);
                if (keys.length == 1) {
                    array.push(keys[0]);
                }
                else {
                    keys.forEach((value, indexx) => {
                        array.push(keys[indexx])
                    })
                }
            })
            array = [...new Set(array)];


            return array?.map((value, index) => {

                return (
                    <option key={index} value={value}>
                        {value}
                    </option>
                );
            });
        } catch (e) {
            throw e;
        }
    }

    // function bindExpInterviewer() {
    //     try {
    //         ;
    //         let interviewerName = [];

    //         expInterviewerDD?.map((value, index) => {
    //             if (job_Id == value.job_id) {
    //                 if (value.scheduled_by == null) {
    //                     interviewerName.push(''); // or handle the case where expInterviewerDD or interviewername is undefined
    //                 } else {
    //                     interviewerName.push(value.scheduled_by);
    //                 }
    //             }
    //         });

    //         let uniqueInterviewer = [...new Set(interviewerName)];

    //         return uniqueInterviewer.map((value, index) => {

    //             const parsedData = JSON.parse(value);
    //             const keys = Object.keys(parsedData);
    //             const optionValue = parsedData[keys[index]];

    //             return (
    //                 <option key={index} value={value}>
    //                     {optionValue}
    //                 </option>
    //             );
    //         });
    //     } catch (e) {
    //         throw e;
    //     }
    // }

    // function bindExpInterviewer() {
    //     try {
    //         let interviewerName=[]

    //         expInterviewerDD.map((value, index) => {
    //             if(job_Id==value.job_id){
    //             if (value.scheduled_by==null ) {
    //                 interviewerName.push(""); // or handle the case where expInterviewerDD or interviewername is undefined
    //              }
    //              else{
    //             interviewerName.push(value.scheduled_by)
    //              }
    //             }
    //         });
    //         let uniqueInterviewer=[...new Set(interviewerName)];
    //         return uniqueInterviewer.map((value, index) => {
    //                         return (
    //                             <option key={index} value={value}>
    //                                 {value}
    //                             </option>
    //                         );
    //                     });

    //     } catch (e) {
    //         throw e;
    //     }
    // }

    let bindInterviewSource = () => {

        try {

            return interviewSourceDD?.map((value, index) => {
                return (
                    <option key={index} value={value.job_source_name}>
                        {value.job_source_name}
                    </option>
                );
            });
        } catch (e) {
            throw e;
        }
    };



    // let bindInterviewSource = () => {
    //     try {
    //         return interviewSourceDd.map((val, index) => {
    //             return (
    //                 <option key={index} value={val.id}>
    //                     {' '}
    //                     {val.interview_source}{' '}
    //                 </option>
    //             );
    //         });
    //     } catch (e) {}
    // };

    //FILTER ONCHANGE
    function filterValueChange(e) {
        if (e.target.name === 'college_name') {
            setFilterData({
                ...FilterData,
                [e.target.name]: e.map(option => option.value)
            });
        } else {
            setFilterData({
                ...FilterData,
                [e.target.name]: e.target.value
            });
        }

        // PC_FC_3 filter onchange
        try {

            setFilterData({ ...FilterData, [e.target.name]: e.target.value }); //PC_FC_5 setstate the FilterData with the current value

        } catch (e) {
            throw e;
        }
    }

    
    const clearFilter = () => {
        try {

            setFilterData(filterObj);
            if (path == '/Recruitment/Jobs') {
                loadCandidate('clear');
            } else {
                loadGrid();
            }
        } catch (e) {
            throw e;
        }
    };

    let convertDate = (date) => {
        return moment(date).format('YYYY-MM-DD');
    };

    // let handleFilter = (FilterData) =>{
    //     loadCandidate(FilterData)
    // }

    let loadMore = async (value) => {
        if (path == '/Recruitment/Jobs') {
        } else {
            let val = gridDataCount > gridData.length ? 10 : loadmore + 10
            setLoadmore(val);

            if (CandidateGrid == '') {
                setloadMoreCheck('LoadMore Click');
                nextPage = gridDataCount > gridData.length ? 10 : nextPage + 10;
                setNextPage(nextPage);

                setIsLoading(false);
                let response = await getAllCandidate({
                    offset: nextPage,
                    sort: columnName,
                });
                setIsLoading(true);

                setGridData([...gridData, ...response.data.data]);
                let response1 = await getCount({
                    sort: columnName,
                });

                setGridDataCount(response1.data.data[0].count);

                let candidateIDArray = [];
                for (let i = 0; i < response.data.data.length; i++) {
                    candidateIDArray.push(response.data.data[i].id);
                }

                let colorfeedback = await overallColorFeedback({
                    job_id: job_Id,
                    candidate_id: candidateIDArray,
                });
                let colorarray = [];

                for (let j = 0; j < colorfeedback.data.data.length; j++) {
                    colorarray.push(colorfeedback.data.data[j].recommendation);

                    //gridColorData = [].concat(...colorfeedback.data.data[j].recommendation);
                    setGridColorData([...gridColorData, ...colorarray]);
                }

                setFlag(!flag);
            } else if (CandidateGrid == 'Filter') {
                setfilterCheck('Filter');
                let val = filterOffset + 10;
                setFilterOffset(val);
                applyFilter(val);
            } else if (CandidateGrid == 'Search') {
                setsearchCheck('search');
                let val = searchOffset + 10;
                setsearchOffset(val);
                handleSearch(val);
            }
        }
    };
    let SpecificJobSearch = async (Search) => {
        try {
            setSearchData(Search)
            if (SearchData == "") {
                setCurrentPage(0)
            }
        }
        catch (e) {
            throw e
        }
    }

    
    let handleSearch = async (SearchData, val) => {
        try {

            //
            let changeValue = SearchData;
            // let value = {
            //     search: searchValue,
            //     job_Id: job_Id,
            // };
            setSearchValue(changeValue);
            if (path == '/Recruitment/Jobs') {
                if (changeValue != '' || changeValue != 'undefined') {
                    let data = {};
                    if (val !== undefined) {
                        data = {
                            search: changeValue,
                            job_id: job_Id,
                            offset: val,
                        };
                    } else {
                        data = {
                            search: changeValue,
                            job_id: job_Id,
                            offset: 0,
                        };
                    }
                    if (exp == 'Fresher') {
                        let res = await getFresherSearchData(data);

                        if (res.data.statusCode == 200) {
                            if (val !== undefined) {
                                setGridData([...gridData, ...res.data.data]);
                                setGridDataCount(res.data.count[0].count);
                                setFlag(!flag);
                            } else {
                                setGridData(res.data.data);
                                setGridDataCount(res.data.count[0].count);
                                setFlag(!flag);
                            }
                        }

                        let candidateIDArray = [];
                        for (let i = 0; i < res.data.data.length; i++) {
                            candidateIDArray.push(res.data.data[i].id);
                        }

                        let colorfeedback = await freshercolorfeedback({
                            job_id: job_Id,
                            candidate_id: candidateIDArray,
                        });
                        let colorarray = [];
                        for (let j = 0; j < colorfeedback.data.data.length; j++) {
                            colorarray.push(colorfeedback.data.data[j].recommendation);
                        }
                        if (val !== undefined) {
                            setGridColorData([...gridColorData, ...colorarray]);
                            setFlag(!flag);
                        } else {
                            setGridColorData(colorarray);
                            setFlag(!flag);
                        }
                    } else {
                        getExpSearchData(data).then((res) => {
                            if (res.data.statusCode == 200) {
                                setGridData(res.data.data);
                                setGridDataCount(res.data.count[0].count);
                                setFlag(!flag);
                            }
                        });
                    }
                    bindGridData();
                } else {
                    loadCandidate();
                }
            } else {
                let searchData = {
                    searchName: changeValue,
                    offset: nextPage,
                };

                if (changeValue != '' || changeValue != 'undefined') {
                    getCandidateSearchData(searchData).then((res) => {
                        if (res.data.statusCode == 200) {
                            setGridData(res.data.data);
                            setGridDataCount(res.data.count[0].count);
                            setFlag(!flag);
                        }
                    });
                    bindGridData();
                } else {
                    loadGrid();
                }
            }
        } catch (e) {
            throw e;
        }
    };

    

    /**
     * PS_24 - PS_41 - With the help of this applyFilter we'll send the  filtering data and to backend 
     *                  and get the filtered data from backend
     */
    const applyFilter = async (FilterDatas, val) => {
        
        try {

            if (path == '/Recruitment/Jobs') {

                loadCandidate(FilterDatas);
            } else {
                // setGridData(FilterDatas);
                var today = new Date();
                let frommmdate = moment(today).format('YYYY-MM-DD');

                //added 2 fields
                if (
                    FilterDatas.status == '' &&
                    FilterDatas.college_name == '' &&
                    FilterDatas.stages == '' &&
                    // FilterDatas.interview_source_id == '' &&
                    FilterDatas.fromDate == '' &&
                    FilterDatas.toDate == '' &&
                    FilterDatas.offerstatus == '' &&
                    FilterDatas.jobId == '' &&
                    FilterDatas.interview_round_name == '' &&
                    FilterDatas.job_source_name == ''
                    // FilterDatas.experience == ''
                ) {
                } else {
                    if (FilterDatas.status != '') {
                        filterObj['status'] = FilterDatas.status;
                    }
                    if (FilterDatas.college_name != '') {
                        filterObj['college'] = FilterDatas.college_name.join(',');
                    }
                    // if (FilterDatas.stage != '') {
                    //     filterObj['stages'] = FilterDatas.stages;
                    // }
                    if (FilterDatas.job_source_name != '') {
                        filterObj['job_source_name'] = FilterDatas.job_source_name;
                    }
                    if (FilterDatas.fromDate != '') {
                        filterObj['fromDate'] = FilterDatas.fromDate;
                    }
                    if (FilterDatas.toDate != '') {
                        filterObj['toDate'] = FilterDatas.toDate;
                    }
                    if (FilterDatas.offerstatus != '') {
                        filterObj['offerletter_status'] = FilterDatas.offerletter_status;
                    }
                    if (FilterDatas.jobId != '') {
                        filterObj['jobId'] = FilterDatas.jobId;
                    }
                    if (FilterDatas.interview_round_name != '') {
                        filterObj['interview_round_name'] = FilterDatas.interview_round_name;
                    }

                }
            }

            if (path == '/Recruitment/Jobs') {
            } else {
                let filterDatas = {};
                if (val !== undefined) {
                    filterDatas = {
                        filtervalue: filterObj,
                        offset: val,
                    };
                } else {
                    filterDatas = {
                        filtervalue: filterObj,
                        offset: filterOffset,
                    };
                }
                let res = await getCandidateFilterData(filterDatas);

                if (res.data.statusCode == 200) {
                    if (val !== undefined) {
                        setGridData([...gridData, ...res.data.data]);
                        setGridDataCount(res.data.count[0].count);
                        setFlag(!flag);
                    } else {
                        setGridData(res.data.data);
                        setGridDataCount(res.data.count[0].count);
                        setFlag(!flag);
                    }

                    let candidateIDArray = [];
                    for (let i = 0; i < res.data.data.length; i++) {
                        candidateIDArray.push(res.data.data[i].id);
                    }

                    let colorfeedback = await overallColorFeedback({
                        job_id: job_Id,
                        candidate_id: candidateIDArray,
                    });
                    let colorarray = [];

                    for (let j = 0; j < colorfeedback.data.data.length; j++) {
                        colorarray.push(colorfeedback.data.data[j].recommendation);

                        //gridColorData = [].concat(...colorfeedback.data.data[j].recommendation);
                        if (val !== undefined) {
                            setGridColorData([...gridColorData, ...colorarray]);
                        } else {
                            setGridColorData(colorarray);
                        }
                    }
                }
            }
        } catch (err) {
            throw err
        }
    };

    // const handleFilteredSort = (gridData,direction='asc')=>{
    //
    //     const sorted = [...gridData].sort((a, b) => {

    //         if (a < b) {
    //             return direction === 'asc' ? -1 : 1;
    //           }

    //           if (a > b) {
    //             return direction === 'asc' ? 1 : -1;
    //           }

    //           return 0;
    //         });

    //         // Now you can set the sorted data using setSortData or use it in your component state as needed
    //         setSortData({ column_name: columnName, order_type: direction });
    //         return sorted;

    //       }

    let sortIconClick = (e, val) => {

        // setGridData('Sort');
        setHideSortIcon({
            ...hideSortIcon,
            [e.target.id.split('-')[0]]: e.target.id.split('-')[1],
        });

        var sortImageId = e.target.id.split('-');

        setSortOrder(sortImageId[1]);
        let sortgridvalue = 'order by ' + sortImageId[0] + ' ' + sortImageId[1];
        setColumnSearch('order by ' + val + '.' + sortImageId[0] + ' ' + sortImageId[1]);

        setColumnName(sortgridvalue);
        if (path == '/Recruitment/Jobs') {
        } else {
            loadGrid(sortgridvalue);
        }
    };
    // Bind the interview round dropdown
    let bindInterviewRound = () => {
        try {
            return interviewDD?.map((val, index) => {
                return (
                    <option key={index} value={val.id} data-name={val.interview_round_name}>
                        {val.interview_round_name}
                    </option>
                );
            });
        } catch (e) { }
    };
    let bindGridData = () => {
        try {
            var color1 = '',
                color2 = '',
                color3 = '',
                color4 = '',
                color5 = '';
            var stage1 = '',
                stage2 = '',
                stage3 = '',
                stage4 = '',
                stage5 = '';
            if (isLoadingLoader == false) {
                return <Loader isLoading={isLoadingLoader} />;
            }

            if (gridData?.length == 0) {
                return (
                    <tr>
                        <td colspan="10" className="accord-content1">
                            <div class="row justify-content-center " style={{ marginTop: '7%', marginBottom: '8%' }}>
                                <img src="/Images/no-records-found.svg" alt="nodatafound" style={{ width: '100px' }} />
                                <h2 class="semibold-text font-20 form-label text-center mt-5 jobdetails-label-color">
                                    No Candidates Found
                                </h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                
                return gridData?.map((value, index) => {
                    let isCheck = candidateRecords.filter(cand => cand.id == value.id && cand.isCheck == true)

                    let array = '';
                    let valuesArray;
                    if (value.scheduled_by) {
                        valuesArray = Object.values(JSON.parse(value.scheduled_by));
                        for (let i = 0; i < valuesArray.length; i++) {
                            array += `${valuesArray[i]},`;
                            array = array.slice(0, -1);
                        }

                    }

                    if (value.stages == 'Sourcing') {
                        color1 = 'rgrid-sourcing';
                        color2 = 'rgrid-unfill';
                        color3 = 'rgrid-unfill';
                        color4 = 'rgrid-unfill';
                        color5 = 'rgrid-unfill';
                        stage1 = '1';
                        stage2 = '';
                        stage3 = '';
                        stage4 = '';
                        stage5 = '';
                    } else if (value.stages == 'Offer') {
                        color1 = 'rgrid-selected';
                        color2 = 'rgrid-selected';
                        color3 = 'rgrid-selected';
                        color4 = 'rgrid-selected';
                        color5 = 'rgrid-unfill';
                        stage1 = '1';
                        stage2 = '2';
                        stage3 = '3';
                        stage4 = '4';
                        stage5 = '';
                    } else if (value.stages == 'Screening') {
                        color1 = 'rgrid-yts';
                        color2 = 'rgrid-yts';
                        color3 = 'rgrid-unfill';
                        color4 = 'rgrid-unfill';
                        color5 = 'rgrid-unfill';
                        stage1 = '1';
                        stage2 = '2';
                        stage3 = '';
                        stage4 = '';
                        stage5 = '';
                    } else if (value.stages == 'Hire') {
                        color1 = 'rgrid-selected';
                        color2 = 'rgrid-selected';
                        color3 = 'rgrid-selected';
                        color4 = 'rgrid-selected';
                        color5 = 'rgrid-selected';
                        stage1 = '1';
                        stage2 = '2';
                        stage3 = '3';
                        stage4 = '4';
                        stage5 = '5';
                    } else if (value.stages == 'Interviews' && gridColorData[index] == 'Selected') {
                        color1 = 'rgrid-selected';
                        color2 = 'rgrid-selected';
                        color3 = 'rgrid-selected';
                        color4 = 'rgrid-unfill';
                        color5 = 'rgrid-unfill';
                        stage1 = '1';
                        stage2 = '2';
                        stage3 = '3';
                        stage4 = '';
                        stage5 = '';
                    } else if (value.stages == 'Interviews' && gridColorData[index] == 'Rejected') {
                        color1 = 'rgrid-rejected';
                        color2 = 'rgrid-rejected';
                        color3 = 'rgrid-rejected';
                        color4 = 'rgrid-unfill';
                        color5 = 'rgrid-unfill';
                        stage1 = '1';
                        stage2 = '2';
                        stage3 = '3';
                        stage4 = '';
                        stage5 = '';
                    } else if (value.stages == 'Interviews' && gridColorData[index] == 'No Show') {
                        color1 = 'rgrid-unfill';
                        color2 = 'rgrid-unfill';
                        color3 = 'rgrid-unfill';
                        color4 = 'rgrid-unfill';
                        color5 = 'rgrid-unfill';
                        stage1 = '1';
                        stage2 = '2';
                        stage3 = '3';
                        stage4 = '';
                        stage5 = '';
                    } else if (value.stages == 'Interviews' && gridColorData[index] == 'Scheduled') {
                        color1 = 'rgrid-sch';
                        color2 = 'rgrid-sch';
                        color3 = 'rgrid-sch';
                        color4 = 'rgrid-unfill';
                        color5 = 'rgrid-unfill';
                        stage1 = '1';
                        stage2 = '2';
                        stage3 = '3';
                        stage4 = '';
                        stage5 = '';
                    } else {
                        color1 = 'rgrid-unfill';
                        color2 = 'rgrid-unfill';
                        color3 = 'rgrid-unfill';
                        color4 = 'rgrid-unfill';
                        color5 = 'rgrid-unfill';
                    }
                    let email_Status = '';
                    if (SelectedRadio.stage == 'Screening') {
                        email_Status = value.status;
                    } else {
                        
                        if (value.status == 'Hold' || value.status == 'Block' || value.status == 'Rejected' || value.status == 'Not Available') {
                            email_Status = value.status;
                        } else {
                            email_Status = gridDataStatus[index]?.recommendation;
                        }
                    }

                    return (
                        //PC_RC_35
                        <tr key={index} className="hive-table-data regular-text align-middle">
                            {/* added conditions to hide and show the td for the respective grids */}
                            <td className="align-items-center">
                                <input
                                    className="form-check-input mt-0 recruitemt-input-checkbox"
                                    type="checkbox"
                                    id={value.id}
                                    name={
                                        value?.offerletter_status +
                                        '@#' +
                                        value?.experience +
                                        '@#' +
                                        job_Id +
                                        '@#' +
                                        email_Status +
                                        '@#' +
                                        value?.email_id +
                                        '@#' +
                                        interviewDD?.interview_round_name +
                                        '@#' +
                                        value.id
                                    }
                                    onChange={(e) => handleCheckbox(e, index, '', email_Status)}
                                    checked={isCheck?.length > 0 ? true : false}
                                />
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <img
                                        src={value.candidate_photo_url}
                                        alt="profile-img"
                                        className="table-image"
                                        style={{ borderRadius: '30px' }}
                                    />
                                    <div className="ms-2">
                                        <a
                                            className="table-name-style semibold-text mb-0"
                                            href={`/Recruitment/CandidateView?id=${value.id}${value.experience == undefined
                                                ? `&exp=${exp}&jId=${job_Id}`
                                                : `&exp=${value.experience}&jId=${value.job_id}`
                                                }`}
                                        >
                                            {value.first_name + ' ' + value.last_name}
                                        </a>
                                    </div>
                                </div>
                            </td>
                            <td>{value.id}</td>
                            {path !== '/Recruitment/Jobs' ? <td>{value.job_title}</td> : <></>}
                            {SelectedRadio.interview_round_name == 'Group Discussion' ? (
                                <td>
                                    <span className="w-10rem text-truncate" style={{ padding: '10px' }}>
                                        {value.batch_no ? `Batch ${value.batch_no}` : '-'}
                                    </span>
                                </td>
                            ) : (
                                <></>
                            )}

                            {/* {SelectedRadio.stage == 'Screening' ? <></> : <td title={array}>{array}</td>} */}
                            {SelectedRadio.stage == 'Screening' ? (
                                <></>
                            ) : (
                                <td>
                                    {' '}
                                    <span className="w-10rem text-truncate" title={array}>
                                        {array}
                                    </span>
                                </td>
                                //     <td>
                                //     {' '}
                                //     <span className="w-10rem text-truncate" title={array.split(',').join(', ')}>
                                //         {array.split(',').join(', ')}
                                //     </span>
                                // </td>
                            )}

                            <td>
                                <span className="w-10rem text-truncate" title={value.email_id}>
                                    {value.email_id}
                                </span>
                            </td>
                            <td>{value.mobile_number}</td>
                            {path !== '/Recruitment' ? (
                                <td style={{ paddingLeft: '25px' }}>
                                    {/* <a href={value.resume_url} className="rgrid-resume-sty mb-0 text-truncate resume-width" target="_blank">
                                    {value.resume_url !== null ? value.resume_url.split('/').pop() : '-'}
                                </a> */}

                                    {/*to  display resume as an icon and on hovering pdf name needs to be shown */}
                                    <a
                                        href="#"
                                        className="rgrid-resume-sty mb-0 text-truncate resume-width"
                                        style={{cursor:"pointer"}} onClick={async () => {

                                            window.open(await getS3(value?.resume_url, "1"), "_blank");
    
    
                                        }} 
                                    >
                                        <img
                                            src="/Images/pdf.svg"
                                            alt={value.resume_url}
                                            title={value.resume_url?.split('/').pop()}
                                            style={{ height: '20px' }}
                                        />
                                        {/* {value.resume_url} */}
                                    </a>
                                </td>
                            ) : <></>
                            }
                            <td>{convertDate(value.created_at)}</td>
                            {/* {path !== '/Recruitment/Jobs' ? (
                                <td>
                                    <div>
                                        <div className="font-12">{value.stages}</div>
                                        <div className="">
                                            <ul className="d-flex list-unstyled">
                                                <li className={`stages ${color1} ms-0`}>{stage1}</li>
                                                <li className={`stages ${color2}`}>{stage2}</li>
                                                <li className={`stages ${color3}`}>{stage3}</li>
                                                <li className={`stages ${color4}`}>{stage4}</li>
                                                <li className={`stages ${color5} me-0`}>{stage5}</li>
                                                <li className=""></li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                            ) : (
                                <></>
                            )} */}
                            {path !== '/Recruitment/Jobs' || SelectedRadio.stage == 'Screening' ? (
                                <td>{value.status == null ? 'Active' : value.status}</td>
                            ) : (
                                <td>
                                    {value.status == 'Hold' || value.status == 'Block' || value.status == 'Not Available' || value.status == 'Scheduled' || value.status == 'Reschedule' || value.status == 'Selected'
                                        ? (
                                            <>
                                                <span>{value.status}</span>
                                                {value.status === 'Not Available' && value.comments ? (
                                                    <Tooltip title={value.comments}>
                                                        <img className="ms-1" src="/Images/tool-tip-icon.svg" alt="tooltip-icon" style={{ cursor: 'pointer' }} />
                                                    </Tooltip>
                                                ) : null}
                                            </>
                                        )
                                        : gridDataStatus[index]?.recommendation}
                                </td>
                            )}
                            {/* status binding */}
                            {path == '/Recruitment/Jobs' && SelectedRadio.stage !== 'Screening' ? (
                                <td>
                                    {gridDataStatus[index]?.is_check == true ?
                                        <span className='sent-badge'>Sent</span> :
                                        <span className='pending-badge'>Pending</span>
                                    }
                                </td>
                            ) : <></>
                            }

                            {/* sender binding */}
                            {path == '/Recruitment/Jobs' && SelectedRadio.stage !== 'Screening' ? (

                                <td>{gridDataStatus[index]?.is_check ? gridDataStatus[index]?.emp_name : '-'}</td>
                            ) : <></>}
                            {path !== '/Recruitment/Jobs' ? (
                                <td>
                                    {(() => {
                                        let displayText = '';
                                        let fullText = '';

                                        if (value.source_id === 1) {
                                            displayText = `${value.job_source_name || ''} - ${value.college_name || ''}`;
                                        } else if (value.source_id === 2) {
                                            displayText = `${value.job_source_name || ''} - ${value.interview_source || ''}`;
                                        } else if (value.source_id === 3) {
                                            displayText = `${value.job_source_name || ''} - ${value.employee_name || ''}`;
                                        } else {
                                            displayText = value.job_source_name || '';
                                        }

                                        fullText = displayText;

                                        if (displayText.length > 18) {
                                            displayText = displayText.substring(0, 18) + '...';
                                        }

                                        return (
                                            <span title={fullText}>
                                                {displayText}
                                            </span>
                                        );
                                    })()}
                                </td>
                            ) : (
                                <></>
                            )}
                            {/* {path !== '/Recruitment/Jobs' ? <td>{value.interview_source}</td> : <></>} */}

                            {path !== '/Recruitment/Jobs' ? <td>{value.interview_round_name ? value.interview_round_name
                                .split(' ')
                                .map((word) => word[0])
                                .join('') : "-"}</td>
                                : <></>}
                            {/* {path !== '/Recruitment/Jobs' ? <td>{value.experience}</td> : <></>} */}

                            {path !== '/Recruitment/Jobs' ||
                                (path == '/Recruitment/Jobs' &&
                                    SelectedRadio.stage !== 'Screening' &&
                                    FinalRound == SelectedRadio.interview_round_id) ? (
                                <td>{value.offerletter_status == undefined ? 'Not Drafted' : value.offerletter_status}</td>
                            ) : (
                                <></>
                            )}
                        </tr>
                    );
                });
            }
        } catch (e) {
            throw e;
        }
    };
    // let checkboxArray = new Array(gridData?.length).fill(false);
    // const [checkArray, setCheckArray] = useState(checkboxArray);

    // let handleCheckbox = (e, index, check, status) => {
    //     //  ;
    //     try {
    //         // Check whether the checkbox is select all checkbox
    //         if (check == 'all') {
    //             if (e.target.checked) {
    //                 setallCheck(true);
    //                 let checkboxArray = new Array(gridData?.length).fill(true);
    //                 setCheckArray(checkboxArray);
    //                 empId = [];
    //                 setEmpId(empId);
    //                 pushAllId(); // function call
    //                 // candidateRecords.length > 0 && setHideBar(false);
    //                 let arrAllCheck = []
    //                 let gridDataStringi = JSON.stringify(gridData)
    //                 let gridDataCLone = JSON.parse(gridDataStringi);
    //                 gridDataCLone.map((val) => val.isCheck = true);
    //                 // gridData.map((val) => arrAllCheck.push(val));
    //                 let localarr = [...candidateRecords, ...gridDataCLone];
    //                 localarr.length > 0 && setHideBar(false);
    //                 setCandidateRecords(localarr);
    //                 setCheckBoxCount(gridData?.length);
    //                 let records = empId.map((id) => {
    //                     let existAlready = candidateRecords.find(candRec => candRec.id == id[0]);

    //                     if (!existAlready) {
    //                         let candidate = gridData.find((item) => item.id === id[0]);
    //                         candidate.isCheck = true;
    //                         return candidate
    //                     }
    //                     return {
    //                         id: -11
    //                     }
    //                 });
    //                 records = records.filter((duplicate) => duplicate.id != -11)
    //                 let localarr1 = [...candidateRecords, ...records]
    //                 // localarr.push(records)
    //                 setCandidateRecords(localarr1);
    //                 //CheckDrafted(empId); // Function call
    //                 let unhold = false;
    //                 let unblock = false;
    //                 let hold = true;
    //                 let block = true;
    //                 let statusarray = [];

    //                 for (let index = 0; index < gridData.length; index++) {
    //                     statusarray.push(gridData[index].status);
    //                     if (gridData[index].status === 'Hold') {
    //                         unhold = true;
    //                         unblock = false;
    //                         hold = false;
    //                         block = true;
    //                     } else {
    //                         unhold = false;
    //                         hold = true;
    //                     }
    //                     if (gridData[index].status === 'Block') {
    //                         unblock = true;
    //                         block = false;
    //                         hold = false;
    //                     } else {
    //                         unblock = false;
    //                         block = true;
    //                     }
    //                     if (gridData[index].status === 'Active') {
    //                         unblock = false;
    //                         block = true;
    //                         hold = true;
    //                         unhold = false;
    //                     }

    //                     if (allAreEqual(statusarray) == false) {
    //                         unblock = false;
    //                         block = false;
    //                         hold = false;
    //                         unhold = false;
    //                     }
    //                     if (gridData[index].offerletter_status === 'Offer Drafted') {
    //                         setActionBarGenerateOffer(false);
    //                     } else {
    //                         setActionBarGenerateOffer(true);
    //                     }
    //                 }
    //                 setunholdflag(unhold);
    //                 setholdflag(hold);
    //                 setunblockflag(unblock);
    //                 setblockflag(block);
    //             } else {
    //                 let checkboxArray = new Array(gridData?.length).fill(false);
    //                 setCheckArray(checkboxArray);
    //                 empId = [];
    //                 setEmpId(empId);
    //                 setCheckBoxCount(0);
    //                 setallCheck(false);
    //                 setShowCandidate([]);
    //                 setCandidateRecords(candidateRecords.filter((r) => !gridData.some((g) => g.id === r.id)));
    //                 // candidateRecords.length == 0 && setHideBar(true);
    //                 // let candids = []
    //                 const candids = gridData.map((grid) => grid.id);
    //                 let filteredCandidates = candidateRecords.filter((r) => !candids.includes(r.id));
    //                 filteredCandidates.length == 0 && setHideBar(true);
    //                 setCandidateRecords(filteredCandidates)
    //                 // map grid if push to arr
    //                 // filter candeidetasl  !candids.includes(id)
    //                 //candidateR.filter((r) => !candids.includes(r.id))
    //             }
    //         } else {
    //             
    //             let array = checkArray;
    //             array[index] = !array[index];
    //             setCheckArray(array);
    //             let arr = array.filter((param) => {
    //                 return param == true;
    //             });
    //             if (arr?.length > 0) {
    //                 setHideBar(false);
    //             } else {
    //                 setHideBar(true);
    //             }
    //             if (array[index] == false) {
    //                 let arrCheck = RemoveId(empId, e.target.id);
    //                 setEmpId(arrCheck);
    //                 
    //                 // let updatedCandidateRecords = RemoveId(candidateRecords, e.target.id);
    //                 let updatedCandidateRecords = candidateRecords.filter(cand => cand.id != e.target.id)
    //                 setCandidateRecords(updatedCandidateRecords);
    //             } else if (array[index] == true) {
    //                 empId.push([
    //                     e.target.id,
    //                     e.target.name.split('@#')[0],
    //                     e.target.name.split('@#')[1],
    //                     e.target.name.split('@#')[2],
    //                     e.target.name.split('@#')[3],
    //                     e.target.name.split('@#')[4],
    //                     e.target.name.split('@#')[5],
    //                     e.target.name.split('@#')[6],
    //                 ]);
    //                 setEmpId(empId);

    //                 let records = empId.map((id) => {
    //                     let existAlready = candidateRecords.find(candRec => candRec.id == id[0]);

    //                     if (!existAlready) {
    //                         let candidate = gridData.find((item) => item.id === id[0]);
    //                         candidate.isCheck = true;
    //                         candidate.status = status;
    //                         return candidate
    //                     }
    //                     return {
    //                         id: -11
    //                     }
    //                 });
    //                 records = records.filter((duplicate) => duplicate.id != -11)
    //                 let localarr = [...candidateRecords, ...records]
    //                 // localarr.push(records)
    //                 setCandidateRecords(localarr);
    //                 // CheckDrafted(empId);
    //             }
    //             setCheckBoxCount(arr?.length);
    //             if (arr?.length == gridData?.length) {
    //                 Refer.current.checked = true;
    //             } else {
    //                 Refer.current.checked = false;
    //             }
    //             if (arr.length == gridData.length) {
    //                 setallCheck(true);
    //             } else {
    //                 setallCheck(false);
    //             }
    //             let unhold = false;
    //             let unblock = false;
    //             let hold = true;
    //             let block = true;
    //             let statusarray = [];
    //             for (let index = 0; index < array.length; index++) {
    //                 if (array[index] == true) {
    //                     statusarray.push(gridData[index].status);
    //                     if (gridData[index].status === 'Hold') {
    //                         unhold = true;
    //                         unblock = false;
    //                         hold = false;
    //                         block = true;
    //                     } else {
    //                         unhold = false;
    //                         hold = true;
    //                     }
    //                     if (gridData[index].status === 'Block') {
    //                         unblock = true;
    //                         block = false;
    //                         hold = false;
    //                     } else {
    //                         unblock = false;
    //                         block = true;
    //                     }
    //                     if (gridData[index].status === 'Active') {
    //                         unblock = false;
    //                         block = true;
    //                         hold = true;
    //                         unhold = false;
    //                     }

    //                     if (allAreEqual(statusarray) == false) {
    //                         unblock = false;
    //                         block = false;
    //                         hold = false;
    //                         unhold = false;
    //                     }
    //                     if (gridData[index].offerletter_status === 'Offer Drafted') {
    //                         setActionBarGenerateOffer(false);
    //                     } else {
    //                         setActionBarGenerateOffer(true);
    //                     }
    //                 }
    //             }
    //             setunholdflag(unhold);
    //             setholdflag(hold);
    //             setunblockflag(unblock);
    //             setblockflag(block);
    //         }
    //     } catch (e) {
    //         throw e;
    //     }
    // };

    let handleCheckbox = (e, index, check, status) => {
        try {

            if (check == 'all') {
                if (e.target.checked) {
                    setallCheck(true);
                    let checkboxArray = new Array(gridData?.length).fill(true);
                    setCheckArray(checkboxArray);
                    empId = [];
                    setEmpId(empId);
                    pushAllId();

                    let arrAllCheck = [];
                    let gridDataStringi = JSON.stringify(gridData);
                    let gridDataCLone = JSON.parse(gridDataStringi);
                    gridDataCLone.forEach((val) => val.isCheck = true);
                    let localarr = [...candidateRecords, ...gridDataCLone];
                    localarr.length > 0 && setHideBar(false);
                    setCandidateRecords(localarr);
                    setCheckBoxCount(gridData?.length);

                    let records = empId.map((id) => {
                        let existAlready = candidateRecords.find(candRec => candRec.id == id[0]);
                        if (!existAlready) {
                            let candidate = gridData.find((item) => item.id === id[0]);
                            candidate.isCheck = true;
                            candidate.status = candidate.status; // Preserve the existing status
                            return candidate;
                        }
                        return { id: -11 };
                    });
                    records = records.filter((duplicate) => duplicate.id != -11);
                    let localarr1 = [...candidateRecords, ...records];
                    setCandidateRecords(localarr1);

                    let unhold = false;
                    let unblock = false;
                    let hold = true;
                    let block = true;
                    let statusarray = [];

                    for (let index = 0; index < gridData.length; index++) {
                        statusarray.push(gridData[index].status);
                        if (gridData[index].status === 'Hold') {
                            unhold = true;
                            unblock = false;
                            hold = false;
                            block = true;
                        } else {
                            unhold = false;
                            hold = true;
                        }
                        if (gridData[index].status === 'Block') {
                            unblock = true;
                            block = false;
                            hold = false;
                        } else {
                            unblock = false;
                            block = true;
                        }
                        if (gridData[index].status === 'Active') {
                            unblock = false;
                            block = true;
                            hold = true;
                            unhold = false;
                        }

                        if (allAreEqual(statusarray) == false) {
                            unblock = false;
                            block = false;
                            hold = false;
                            unhold = false;
                        }
                        if (gridData[index].offerletter_status === 'Offer Drafted') {
                            setActionBarGenerateOffer(false);
                        } else {
                            setActionBarGenerateOffer(true);
                        }
                    }
                    setunholdflag(unhold);
                    setholdflag(hold);
                    setunblockflag(unblock);
                    setblockflag(block);
                } else {
                    let checkboxArray = new Array(gridData?.length).fill(false);
                    setCheckArray(checkboxArray);
                    empId = [];
                    setEmpId(empId);
                    setCheckBoxCount(0);
                    setallCheck(false);
                    setShowCandidate([]);
                    setCandidateRecords(candidateRecords.filter((r) => !gridData.some((g) => g.id === r.id)));

                    const candids = gridData.map((grid) => grid.id);
                    let filteredCandidates = candidateRecords.filter((r) => !candids.includes(r.id));
                    filteredCandidates.length == 0 && setHideBar(true);
                    setCandidateRecords(filteredCandidates);
                }
            } else {
                let array;
                array = [...checkArray];
                array[index] = !array[index];
                setCheckArray(array);

                let arr = array.filter((param) => param == true);
                setHideBar(arr.length > 0 ? false : true);

                if (!array[index]) {
                    let arrCheck = RemoveId(empId, e.target.id);
                    setEmpId(arrCheck);
                    setCandidateRecords(candidateRecords.filter(cand => cand.id != e.target.id));
                } else {
                    empId.push([
                        e.target.id,
                        e.target.name.split('@#')[0],
                        e.target.name.split('@#')[1],
                        e.target.name.split('@#')[2],
                        e.target.name.split('@#')[3],
                        e.target.name.split('@#')[4],
                        e.target.name.split('@#')[5],
                        e.target.name.split('@#')[6],
                    ]);
                    setEmpId(empId);

                    let records = empId.map((id) => {
                        let existAlready = candidateRecords.find(candRec => candRec.id == id[0]);
                        if (!existAlready) {
                            let candidate = gridData.find((item) => item.id === id[0]);
                            candidate.isCheck = true;
                            candidate.status = candidate.status; // Preserve the existing status
                            return candidate;
                        }
                        return { id: -11 };
                    });
                    records = records.filter((duplicate) => duplicate.id != -11);
                    let localarr = [...candidateRecords, ...records];
                    setCandidateRecords(localarr);
                }

                setCheckBoxCount(arr.length);
                if (arr.length == gridData.length) {
                    Refer.current.checked = true;
                } else {
                    Refer.current.checked = false;
                }

                if (arr.length == gridData.length) {
                    setallCheck(true);
                } else {
                    setallCheck(false);
                }

                let unhold = false;
                let unblock = false;
                let hold = true;
                let block = true;
                let statusarray = [];
                for (let index = 0; index < array.length; index++) {
                    
                    if (array[index] == true) {
                        statusarray.push(gridData[index].status);
                        if (gridData[index].status === 'Hold') {
                            unhold = true;
                            unblock = false;
                            hold = false;
                            block = true;
                        } else {
                            unhold = false;
                            hold = true;
                        }
                        if (gridData[index].status === 'Block') {
                            unblock = true;
                            block = false;
                            hold = false;
                        } else {
                            unblock = false;
                            block = true;
                        }
                        if (gridData[index].status === 'Active') {
                            unblock = false;
                            block = true;
                            hold = true;
                            unhold = false;
                        }

                        if (allAreEqual(statusarray) == false) {
                            unblock = false;
                            block = false;
                            hold = false;
                            unhold = false;
                        }
                        if (gridData[index].offerletter_status === 'Offer Drafted') {
                            setActionBarGenerateOffer(false);
                        } else {
                            setActionBarGenerateOffer(true);
                        }
                    }
                }
                setunholdflag(unhold);
                setholdflag(hold);
                setunblockflag(unblock);
                setblockflag(block);
            }
        } catch (e) {
            throw e;
        }
    };


    let timeDiff = (stime, etime) => {
        var start = stime.split(':');
        var end = etime.split(':');

        var date1 = new Date(2000, 0, 1, start[0], start[1]);
        var date2 = new Date(2000, 0, 1, end[0], end[1]);
        var dif = date2 - date1;

        var msec = dif;
        var hh = Math.floor(msec / 1000 / 60 / 60);
        msec -= hh * 1000 * 60 * 60;
        var mm = Math.floor(msec / 1000 / 60);
        msec -= mm * 1000 * 60;
        var minutes = hh * 60;
        if (hh == 0) {
            return mm;
        } else if (hh == 1) {
            return minutes;
        } else if (hh > 1) {
            // return hh > 1 && mm == 0 ? hh + ' hrs' : hh + ' hrs ' + mm + ' mins';
            return minutes;
        } else {
            return '';
        }
    };

    let pushAllId = () => {
        gridData?.map((obj) => {
            empId.push([obj.id, obj.offerletter_status, obj.experience, obj.job_id, obj.status, obj.email_id, undefined, obj.id]);
        });
        setEmpId(empId);
    };

    function allAreEqual(array) {
        if (array.length > 0) {
            const result = array.every((element) => {
                if (element === array[0]) {
                    return true;
                }
            });

            return result;
        }

        return false;
    }

    let bindcandidatename = (values, e) => {
        let samplearray = [];
        for (let i = 0; i <= empId.length - 1; i++) {
            let objresponse = {
                value: empId[i][5],

                img: '/Images/logo-person-user-person-icon.jpg',

                label: empId[i][5],

                username: empId[i][5],

                status: empId[i][4],

                experience: empId[i][2],

                job_id: empId[i][3],

                interview_round_name: empId[i][6],

                candidate_id: empId[i][7],
            };

            samplearray.push(objresponse);
        }

        setShowCandidate(samplearray);
    };

    let RemoveId = (arr, value) => {
        return arr.filter((param) => {
            return !(param[0] == value);
        });
    };

    let cancelClick = (value) => {
        if (value == 'confirmation-pop') {
            setConfirmationContainer(true);
        } else {
            setShowCandidate([]);
            setEmpId([]);
            if (value == 'Hold') {
                var holdCandidateObj = {
                    candidate_id: '',
                    job_id: '',
                    email: '',
                    reason_for_hold: '',
                };
                setHoldData(holdCandidateObj);
            } else if (value == 'interview') {
                var interview = {
                    candidate_id: '',
                    job_id: '',
                    title: '',
                    meeting_details: '',
                    interview_round_id: '',
                    interview_date: '',
                    start_time: '',
                    end_time: '',
                    is_active: '',
                };
                setScheduleData(interview);
            } else if (value == 'Move') {
                setInterchangeData({ job_id: '', job_title: '' });
            }
            let checkboxArray = new Array(gridData?.length).fill(false);
            setCheckArray(checkboxArray);
            setCandidateRecords([]);
        }
    };

    let onValueChange = (values, e) => {
        // var today = new Date();
        // var nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
        // nextweek = convertDate(nextweek);

        // let date1 = new Date();
        // let date2 = new Date();
        // date1.setMonth(date1.getMonth() + 1);
        // var Date1 = convertDate(date1);
        // date2.setMonth(date2.getMonth() + 3);
        // var Date2 = convertDate(date2);

        // if (values == '1 week') {
        //     holdData.hold_until_date = nextweek;
        //     holdData.hold_until_duration = values;
        // } else if (values == '1 month') {
        //     holdData.hold_until_date = Date1;
        //     holdData.hold_until_duration = values;
        // } else if (values == '3 months') {
        //     holdData.hold_until_date = Date2;
        //     holdData.hold_until_duration = values;

        // if (values == 'email') {
        //     holdData.email = e.target.value;
        // } else if (values == 'Description') {
        //     holdData.reason_for_hold = e.target.value;
        // }
        // setHoldData({ ...holdData });

        let email = [];
        if (values == 'Description') {
            holdData.reason_for_hold = e.target.value;
        } else {
            for (let z = 0; z < showCandidate.length; z++) {
                email.push(showCandidate[z].value);
            }
        }
        setHoldData({ ...holdData });
    };

    //PC_HC_40 function to block or reject the candidate
    let rejectOrBlockClick = async (value) => {
        let candiFresher = [];
        let candiExp = [];
        empId?.map((obj) => {
            if (obj[2] == 'Fresher') {
                candiFresher.push(obj[0]);
            } else {
                candiExp.push(obj[0]);
            }
        });
        //PC_HC_41 condition to check whether fresher candidateID is present
        if (candiFresher?.length > 0) {
            let resp = await updateFresherStatus({ status: value, id: candiFresher }); //PC_HC_42 call the update status function to update the status for fresher
        }
        //PC_HC_53 condition to check whether experienced candidateID is present
        if (candiExp?.length > 0) {
            let resp1 = await updateExpStatus({ status: value, id: candiExp }); //PC_HC_53 call the update status function to update the status for experienced
        }
        setEmpId([]);
        setRenderFlag(!renderFlag);
        candidateRecords.length == 0 && setHideBar(true);
        setCheckArray(checkboxArray);
        setallCheck(false);
    };

    let holdvalidation = () => {
        let result = true;
        //added candidate;s email
        // if (holdData.email == '') {
        //     holdErrData.email = 'Candidate email is required';
        //     setHoldErrData({ ...holdErrData });
        //     result = false;
        // } else {
        //     holdErrData.email = '';
        //     setHoldErrData({ ...holdErrData });
        // }
        if (holdData.reason_for_hold == '') {
            holdErrData.reason_for_hold = 'Reason for hold is required';
            setHoldErrData({ ...holdErrData });
            result = false;
        } else {
            let checkregex = OnlyNumberSpecialChar(holdData.reason_for_hold);
            if (checkregex) {
                holdErrData.reason_for_hold = 'Valid Reason for hold is required';
                setHoldErrData({ ...holdErrData });
                result = false;
            } else {
                holdErrData.reason_for_hold = '';
                setHoldErrData({ ...holdErrData });
            }
        }
        return result;
    };
    let interchangeValidation = () => {
        let result = true;
        if (interchangeData.job_title == '') {
            interchangeErrorData.job_title = 'Job is required';
            setinterchangeErrData({ ...interchangeErrorData });
            result = false;
        } else {
            interchangeErrorData.job_title = '';
            setinterchangeErrData({ ...interchangeErrorData });
        }

        return result;
    };
    function formatTime(time) {
        const [hours, minutes] = time.split(':');
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    }
    /**
     * PS_RE_09 - PS_RE_11 - the interview schedule message will be send based on schedule or reschedule 
     */
    let scheduleInterviewClick = async () => {
        
        //PC_BI_16 -> round name is checked and respective API call is made
        setHideSchedule(true);
        setHideBar(true);
        if (interviewData.availabilityStatus === 'Available') {
            // if (SelectedRadio.stage == 'Screening') {
            let email_ids = [];
            let interviewer_email_ids = [];
            for (let z = 0; z < showCandidate.length; z++) {
                email_ids.push(showCandidate[z].value);
            }
            if (selectedPeopleList && selectedPeopleList.email_id) {
                interviewer_email_ids.push(selectedPeopleList.email_id);
            }

            if (isReschedule) {
                
                interviewData.schedule = 'Reschedule';
            } else {
                interviewData.schedule = 'Schedule';
            }

            let teams_start = interviewData.start_time.split(':');
            let teams_end = interviewData.end_time.split(':');

            let interview_start_time;
            let interview_end_time;
            let newstart, newstart1;
            let newend, newend1;
            if (teams_start[1] >= 0 && teams_start[1] < 10 && Math.floor(teams_start[1]) == teams_start[1]) {
                newstart = `0${teams_start[1]}`;

                // interview_start_time = `${teams_start[0]}:${newstart}`;
            } else {
                newstart = teams_start[1];
                // interview_start_time = interviewData.start_time;
            }
            if (teams_end[1] >= 0 && teams_end[1] < 10 && Math.floor(teams_end[1]) == teams_end[1]) {
                newend = `0${teams_end[1]}`;

                // interview_end_time = `${teams_end[0]}:${newend}`;
            } else {
                // interview_end_time = interviewData.end_time;
                newend = teams_end[1];
            }

            if (teams_start[0] >= 0 && teams_start[0] < 10 && Math.floor(teams_start[0]) == teams_start[0]) {
                newstart1 = `0${teams_start[0]}`;

                // interview_start_time = `${teams_start[0]}:${newstart}`;
            } else {
                newstart1 = teams_start[0];
                // interview_start_time = interviewData.start_time;
            }
            if (teams_end[0] >= 0 && teams_end[0] < 10 && Math.floor(teams_end[0]) == teams_end[0]) {
                newend1 = `0${teams_end[0]}`;

                // interview_end_time = `${teams_end[0]}:${newend}`;
            } else {
                newend1 = teams_end[0];
                // interview_end_time = interviewData.end_time;
            }
            interview_end_time = `${newend1}:${newend}`;
            interview_start_time = `${newstart1}:${newstart}`;

            let start = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_start_time}.2444915-07:00`;

            let end = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_end_time}.2444915-07:00`;

            // let start = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interviewData.start_time}.2444915-07:00`;
            //
            // let end = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interviewData.end_time}.2444915-07:00`;
            //

            let response;
            let checkboxArray = new Array(gridData?.length).fill(false);
            setCheckArray(checkboxArray);

            // for (let i = 0; i < empId.length; i++) {
            //     let val = empId[i][0];
            //     interviewData.candidate_id.push(val);
            // }

            interviewData.job_id = job_Id;
            // interviewData.candidates = '1010';
            let val = selectedPeopleList;

            let obj = {};
            let email = [];
            // let objresponse = {
            //     value: UserId,
            //     img: '/Images/logo-person-user-person-icon.jpg',
            //     label: UserName,
            //     username: UserName,
            // };

            for (let i = 0; i < selectedPeopleList.length; i++) {
                
                obj[i + 1] = selectedPeopleList[i].username;

                interviewer_email_ids.push(selectedPeopleList[i].email_id);
            }
            //val.push(UserName);
            interviewData.scheduled_by = obj;
            //interviewData.scheduled_by = UserName;
            // interviewData.interviewers = emp;
            let teamsInvite;
            if (validation(start, end) == true) {
                setIsLoading(false);
                let insertdata = interviewData;
                let teams = {
                    startDateTime: start,
                    endDateTime: end,
                    subject: interviewData.interview_round_name,
                };

                teamsInvite = await getTeamsInvite(teams);
                //
                let batchCheck;
                if(interviewData.interview_round_name == 'Group Discussion'){
                let batchResponse = await getBatchDetails({
                    job_id: job_Id,
                    experience: exp,
                });
                
                //PC_BI_07 -> condition for statusCode is checked and batchNo is set stated
                if (batchResponse.data.statusCode == 200) {
                    
                    if (batchResponse?.data?.data?.length == 0) {
                        batchCheck = 0; // Start from 1 if no previous batch
                    } else {
                        batchCheck = batchResponse?.data?.data[0]?.batch_no; // Increment the latest batch number
                    }
                    batchCheck++
                    }
                    setBatchNo(batchCheck);

            }
//
                insertdata['teams_invite'] = teamsInvite?.data?.ResponseData?.joinWebUrl;
                
                insertdata['batchNo'] = batchCheck;
                insertdata['candidate_id'] = []
                for (let i = 0; i < showCandidate.length; i++) {
                    // let val = empId[i][0];
                    interviewData?.candidate_id?.push(showCandidate[i].candidate_id);
                }
                //
                setShowCandidate([]);
                let response1;
                if (submitInterviewMode == 'Insert') {
                    
                    if (props.exp == 'Fresher') {
                        setIsLoading(false);
                        response = await postBulkInterview(interviewData);

                        setIsLoading(true);
                    } else if (props.exp == 'Experienced') {
                        setIsLoading(false);
                        response = await postExpBulkInterview(interviewData);

                        setIsLoading(true);
                    }
                    // let reason = `Interview scheduled for ${JobTitle}- ${interviewRound} stage with ${candidateName}
                    // at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;
                    // let payload = {
                    //     icon_category: 'Meeting',
                    //     candidateType: props.exp,
                    //     audit_reason: reason,
                    //     candidate_id: interviewData.candidate_id,
                    //     job_id: job_Id,
                    // };

                    // let response1 = await postTimeline(payload);

                    let data = {
                        exp: props.exp,
                        candidate_id: interviewData.candidate_id,
                        stage: 'Screening',
                        stages: 'Interviews',
                    };

                    postHireStage(data).then((res) => {
                        if (res.data.statusCode == 200) {
                        }
                    });
                    
                    //Post timeline scenario been added in here.
                    const name = candidateRecords[0]?.first_name || '';
                    setCandidateName(name);
                    let Hour = timeDiff(interviewData.start_time, interviewData.end_time)
                    let reason = `Interview scheduled for ${jobTitle}- ${interviewData.interview_round_name} stage with ${candidateName}
                    at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;

                    let payload = {
                        icon_category: 'Meeting',
                        candidateType: props.exp,
                        audit_reason: reason,
                        candidate_id: interviewData.candidate_id[0],
                        job_id: job_Id,
                    };

                    response1 = await postTimeline(payload);
                } else if (submitInterviewMode == 'Edit') {
                    let insertdata = interviewData;

                    let teams = {
                        startDateTime: start,
                        endDateTime: end,
                        subject: interviewData.interview_round_name,
                    };
                    let teamsInvite = await getTeamsInvite(teams);

                    insertdata['teams_invite'] = teamsInvite?.data?.ResponseData?.joinWebUrl;
                    
                    if (props.exp == 'Fresher') {
                        
                        setIsLoading(false);
                        response = await updateInterview(insertdata);
                        setIsLoading(true);
                    } else if (props.exp == 'Experienced') {
                        setIsLoading(false);
                        response = await updateExpInterview(insertdata);
                        setIsLoading(true);
                    }
                }
                if (response1?.data?.statusCode == 200) {
                    setHideSchedule(true);
                    setallCheck(false);

                    let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');
                    let formattedStartTime = formatTime(interviewData.start_time);

                    let content = {
                        Subject: '',
                        body: '',
                        to: [email_ids]
                    }
                    let interviewer_content = {
                        Subject: '',
                        body: '',
                        to: [interviewer_email_ids]
                    }

                    if (isReschedule) {
                        //debugger
                        // Construct the reschedule email content.
                        content.Subject = "Interview Rescheduled - Invite";
                        content.body = `<html lang="en">
                        
                        <head>
                        <meta charset='utf-8'>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <title>Invite User</title>
                        </head>
                        
                        <body>
                        <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                        <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                            <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                            </div>
                        </div>
                        
                        <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                        <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            We are writing to inform you that we have rescheduled our previously arranged interview.<br/><br/>
                            Updated Interview Details:<br/><br/>
                            • Rescheduled Date and Time:<br/><br/>${date} and ${formattedStartTime}
                            Please use the following link to join the interview at the scheduled time:<br/><br/>
                            Teams Invite Link:<br/><br/>
                    <a href="${teamsInvite?.data?.ResponseData?.joinWebUrl}">
                    ${teamsInvite?.data?.ResponseData?.joinWebUrl}</a>
                 <br/><br/>
                    Please click in the following link: <a href="https://hivecandidate.avasoft.com?id=${interviewData.job_id}">https://hivecandidate.avasoft.com?id=${interviewData.job_id}</a>
                        </p>
                        <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                        Yours Truly,
                        </p>
                        <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                        Team Avasoft
                        </p>
                        </div>
                        </div>
                        
                        </div>
                        </body>
                        </html>`;

                        interviewer_content.Subject = "AVASOFT-Interview Schedule";
                        interviewer_content.body = `<html lang="en">
                <head>
                    <meta charset='utf-8'>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Interview Schedule</title>
                </head>
                <body>
                    <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                        <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                                <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                            </div>
                        </div>
                        <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                            <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                                <h3 style="font-size: 20px; color: #F29B10;">
                                    Dear Interviewer,
                                </h3>
                                <p style="font-size: 16px; color: #0f0f0f;">
                                    You are invited to conduct an interview.<br/><br/>
                                    Interview Details:<br/><br/>
                                    • Date and Time: ${date} at ${formattedStartTime}<br/>
                                    • Interview Round: ${interviewData.interview_round_name}<br/><br/>
                                    Please use the following link to join the interview at the scheduled time:<br/><br/>
                                    Teams Invite Link:<br/>
                                    <a href="${teamsInvite?.data?.ResponseData?.joinWebUrl}">${teamsInvite?.data?.ResponseData?.joinWebUrl}</a>
                                    <br/><br/>
                                    If you experience any technical difficulties or are unable to access the link, please don't hesitate to contact the HR team.
                                </p>
                                <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                                    Best regards,
                                </p>
                                <p style="font-size: 16px; font-weight:bold; color: #F29B10;">
                                    Team Avasoft
                                </p>
                            </div>
                        </div>
                    </div>
                </body>
                </html>`;
                    }
                    
                    sendMail(content);
                    // interviewer_content.to = ['sukeesh.s@avasoft.com']
                    sendMail(interviewer_content);
                    setRenderFlag(!renderFlag);
                }
               
                setIsLoading(true);
                setCandidateRecords([])
            } else {
                setIsLoading(true);
            }
            interviewCancelClick();
            setRenderFlag(!renderFlag)
            setShowCandidate([]);
            setCandidateGrid([])
            // setEmpId([]);
        }
        // else {
        //     let email_ids = [];
        //     for (let z = 0; z < showCandidate.length; z++) {
        //         email_ids.push(showCandidate[z].value);
        //     }
        //     let teams_start = interviewData.start_time.split(':');
        //     let teams_end = interviewData.end_time.split(':');

        //     let interview_start_time;
        //     let interview_end_time;
        //     let newstart, newstart1;
        //     let newend, newend1;
        //     if (teams_start[1] >= 0 && teams_start[1] < 10 && Math.floor(teams_start[1]) == teams_start[1]) {
        //         newstart = `0${teams_start[1]}`;
        //         if (newstart.length == 3) {
        //             newstart = newstart.slice(1, 3);
        //         }

        //         // interview_start_time = `${teams_start[0]}:${newstart}`;
        //     } else {
        //         newstart = teams_start[1];
        //         // interview_start_time = interviewData.start_time;
        //     }
        //     if (teams_end[1] >= 0 && teams_end[1] < 10 && Math.floor(teams_end[1]) == teams_end[1]) {
        //         newend = `0${teams_end[1]}`;
        //         if (newend.length == 3) {
        //             newend = newend.slice(1, 3);
        //         }

        //         // interview_end_time = `${teams_end[0]}:${newend}`;
        //     } else {
        //         // interview_end_time = interviewData.end_time;
        //         newend = teams_end[1];
        //     }

        //     if (teams_start[0] >= 0 && teams_start[0] < 10 && Math.floor(teams_start[0]) == teams_start[0]) {
        //         newstart1 = `0${teams_start[0]}`;
        //         if (newstart1.length == 3) {
        //             newstart1 = newstart1.slice(1, 3);
        //         }

        //         // interview_start_time = `${teams_start[0]}:${newstart}`;
        //     } else {
        //         newstart1 = teams_start[0];
        //         // interview_start_time = interviewData.start_time;
        //     }
        //     if (teams_end[0] >= 0 && teams_end[0] < 10 && Math.floor(teams_end[0]) == teams_end[0]) {
        //         newend1 = `0${teams_end[0]}`;
        //         if (newend1.length == 3) {
        //             newend1 = newend1.slice(1, 3);
        //         }

        //         // interview_end_time = `${teams_end[0]}:${newend}`;
        //     } else {
        //         newend1 = teams_end[0];
        //         // interview_end_time = interviewData.end_time;
        //     }
        //     interview_end_time = `${newend1}:${newend}`;
        //     interview_start_time = `${newstart1}:${newstart}`;

        //     let start = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_start_time}.2444915-07:00`;

        //     let end = `${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_end_time}.2444915-07:00`;

        //     let startTime = new Date(`${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_start_time}:00`);
        //     let endTime = new Date(`${moment(interviewData.interview_date).format('YYYY-MM-DD')}T${interview_end_time}:00`);

        //     let Hour = timeDiff(interviewData.start_time, interviewData.end_time);
        //     let timeDiffr = Hour / checkBoxCount;
        //     let response;
        //     let timeStartArr = [];
        //     let timeEndArr = [];
        //     // interviewData.candidate_id = props.candidate_id;
        //     for (let i = 0; i < showCandidate.length; i++) {
        //         // let val = empId[i][0];
        //         // interviewData?.candidate_id?.push(showCandidate[i].candidate_id);
        //         let startT = new Date(startTime.getTime() + i * ((endTime - startTime) / checkBoxCount));
        //         let endT = new Date(startT.getTime() + timeDiffr * 60 * 1000);

        //         startT = `${startT.getHours()}:${startT.getMinutes()}`;
        //         endT = `${endT.getHours()}:${endT.getMinutes()}`;
        //         timeStartArr.push(startT);
        //         timeEndArr.push(endT);

        //         // interviewData.start_time.push(start);
        //         // interviewData.end_time.push(end);
        //     }
        //     interviewData.start_time = timeStartArr;
        //     interviewData.end_time = timeEndArr;
        //     interviewData.job_id = job_Id;
        //     interviewData.candidates = props.candidate_id;

        //     let val = selectedPeopleList;
        //     let arrEmail = [];

        //     let obj = {};

        //     for (let i = 0; i < selectedPeopleList.length; i++) {
        //         obj[i + 1] = selectedPeopleList[i].username;
        //         arrEmail.push(selectedPeopleList[i].email_id);
        //     }
        //     arrEmail.push(props.email);
        //     interviewData.scheduled_by = obj;

        //     // if (validation(start, end) == true) {
        //     setIsLoadingLoader(false);
        //     let insertdata = interviewData;
        //     let teams = {
        //         startDateTime: start,
        //         endDateTime: end,
        //         subject: interviewData.interview_round_name,
        //     };

        //     let teamsInvite = await getTeamsInvite(teams);

        //     insertdata['teams_invite'] = teamsInvite?.data?.ResponseData?.joinWebUrl;
        //     insertdata['experience'] = props.exp;
        //     insertdata['email_ids'] = email_ids;
        //     insertdata['candidate_id'] = []
        //     for (let i = 0; i < showCandidate.length; i++) {
        //         // let val = empId[i][0];
        //         interviewData?.candidate_id?.push(showCandidate[i].candidate_id);
        //     }
        //     if (submitInterviewMode == 'Insert') {
        //         // if (props.experience == 'Fresher') {
        //         //     response = await postInterview(insertdata);
        //         // } else if (props.experience == 'Experienced') {
        //         //     response = await postExpInterview(insertdata);

        //         // }
        //         let scheduledResponse = await insertBulkInterviewData(insertdata);
        //         //PC_BI_20 -> conditionn for response is checked
        //         if (scheduledResponse.statusCode == 200) {
        //             response = scheduledResponse;
        //         }
        //         let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');

        //         let reason = `Interview scheduled for ${jobTitle}- ${interviewRound} stage with ${candidateName}
        //                 at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;

        //         let payload = {
        //             icon_category: 'Meeting',
        //             candidateType: props.experience,
        //             audit_reason: reason,
        //             candidate_id: props.candidate_id,
        //             job_id: job_Id,
        //         };

        //         let response1 = await postTimeline(payload);
        //         let data = {
        //             exp: props.experience,
        //             candidate_id: props.candidate_id,
        //             stage: 'Interviews',
        //         };
        //         postStages(data).then((res) => {
        //             if (res.data.statusCode == 200) {
        //             }
        //         });
        //         setIsLoadingLoader(true);
        //         interviewCancelClick();
        //         setRenderFlag(!renderFlag);
        //     } else if (submitInterviewMode == 'Edit') {
        //         let insertdata = interviewData;

        //         let teams = {
        //             startDateTime: start,
        //             endDateTime: end,
        //             subject: interviewData.interview_round_name,
        //         };

        //         let teamsInvite = await getTeamsInvite(teams);

        //         insertdata['teams_invite'] = teamsInvite?.data?.ResponseData?.joinWebUrl;
        //         if (props.exp == 'Fresher') {
        //             response = await updateInterview(insertdata);
        //             let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');
        //             let reason = `Interview scheduled for ${jobTitle}- ${interviewRound} stage with ${candidateName}
        //                 at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;
        //             let payload = {
        //                 icon_category: 'Meeting',

        //                 candidateType: 'Fresher',

        //                 audit_reason: reason,

        //                 candidate_id: props.candidate_id,

        //                 job_id: props.job_id,
        //             };

        //             let response1 = await postTimeline(payload);
        //         } else if (props.exp == 'Experienced') {
        //             response = await updateExpInterview(insertdata);
        //             let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');
        //             let reason = `Interview scheduled for ${jobTitle}- ${interviewRound} stage with ${candidateName}
        //                 at ${date} ${interviewData.start_time} for ${Hour} by ${UserName}`;
        //             let payload = {
        //                 icon_category: 'Meeting',

        //                 candidateType: 'Experienced',

        //                 audit_reason: reason,

        //                 candidate_id: props.candidate_id,

        //                 job_id: job_Id,
        //             };

        //             let response1 = await postTimeline(payload);
        //         }

        //         let data = {
        //             exp: props.experience,
        //             candidate_id: props.candidate_id,
        //             stage: 'Interviews',
        //         };
        //         // postStages(data).then((res) => {
        //         //     if (res.data.statusCode == 200) {
        //         //     }
        //         // });
        //         interviewCancelClick();
        //     }
        //     let data = {
        //         modulename: 12,
        //         methodname: 1,
        //     };

        //     let res = await getLogin1(JSON.stringify(data));

        //     if (response?.data?.statusCode == 200) {
        //         //     let date = moment(new Date(interviewData.interview_date)).format('MMM DD, YYYY');
        //         //     let interview;
        //         //     if (interviewRound == undefined) {
        //         //         interview = 'Group Discussion';
        //         //     } else {
        //         //         interview = interviewRound;
        //         //     }
        //         //     let content = {
        //         //         Subject: `Invite for ${interview}`,
        //         //         body: `<html lang="en">

        //         //         <head>
        //         //           <meta charset='utf-8'>
        //         //           <meta name="viewport" content="width=device-width, initial-scale=1.0">
        //         //           <title>Invite User</title>
        //         //         </head>

        //         //         <body>
        //         //           <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
        //         //            <div style="background-color:#ffffff; width: 100%;">
        //         //             <div style="padding: 15px 32px; background-color: #ffffff;">
        //         //              <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
        //         //             </div>
        //         //            </div>

        //         //            <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
        //         //            <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
        //         //             <h3 style=" font-size: 20px; color: #F29B10;">
        //         //             Hi ${candidateName},
        //         //             </h3>
        //         //             <p style=" font-size: 16px; color: #0f0f0f;">
        //         //             As discussed, please join the ${interview} on ${date} at ${interviewData.start_time} using below meeting link.<br/><br />
        //         //             Teams invite link:<br/>
        //         //             ${teamsInvite.data.ResponseData.joinWebUrl}.<br/><br/>
        //         //             Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${interviewData.job_id}"> https://hivecandidate.avasoft.com?id=${interviewData.job_id} </a>
        //         //           </p>
        //         //           <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
        //         //            Yours Truly,
        //         //            </p>
        //         //           <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
        //         //            Team Avasoft
        //         //            </p>
        //         //            </div>
        //         //           </div>

        //         //         </div>
        //         //         </body>
        //         //         </html>`,
        //         //         to: [arrEmail],
        //         //     };
        //         //     sendMail(content);
        //         // }

        //         setRenderFlag(!renderFlag);
        //         //setIsLoadingLoader(true);
        //         setShowContainer(false);
        //     } else {
        //         // setIsLoadingLoader(true);
        //     }
        //     // }

        else if (interviewData.availabilityStatus === 'Not Available') {
            
            let response;
            let ids = [];
            let obj = {};
            let checkboxArray = new Array(gridData?.length).fill(false);
            setCheckArray(checkboxArray);
            for (let i = 0; i < candidateRecords.length; i++) {
                // let val = empId[i][0];
                ids?.push(candidateRecords[i].id);
            }
            //
            for (let i = 0; i < selectedPeopleList.length; i++) {
                obj[i + 1] = selectedPeopleList[i].username;
            }
            let insertdata = interviewData
            insertdata.candidate_id = ids
            insertdata.job_id = job_Id
            insertdata.scheduled_by = obj

            if (submitInterviewMode == 'Insert') {
                if (props.exp == 'Fresher') {
                    setIsLoading(false);
                    response = await postBulkInterview(insertdata);
                    //debugger
                    setIsLoading(true);
                    let data = {
                        exp: props.exp,
                        candidate_id: ids,
                        stage: 'Screening',
                        stages: 'Interviews',
                    };

                    postHireStage(data).then((res) => {
                        if (res.data.statusCode == 200) {
                        }
                    });

                } else if (props.exp == 'Experienced') {
                    setIsLoading(false);
                    response = await postExpBulkInterview(insertdata);
                    //debugger
                    setIsLoading(true);
                    let data = {
                        exp: props.exp,
                        candidate_id: interviewData.ids,
                        stage: 'Screening',
                        stages: 'Interviews',
                    };

                    postHireStage(data).then((res) => {
                        if (res.data.statusCode == 200) {
                        }
                    });
                }

            }
            else if (submitInterviewMode == 'Edit') {

                if (props.exp == 'Fresher') {
                    setIsLoading(false);
                    response = await updateInterview(insertdata);
                    setIsLoading(true);
                } else if (props.exp == 'Experienced') {
                    setIsLoading(false);
                    response = await updateExpInterview(insertdata);
                    setIsLoading(true);
                }
            }
            // }
            interviewCancelClick();
            setCandidateGrid([])
            setShowCandidate([])
            setCandidateRecords([])
            setRenderFlag(!renderFlag);
        };
    }


    //PC_EM_05 -> onEmailSchedule() is defined and sendMailCandidate() Api call is made
    let onEmailSchedule = async () => {

        setIsLoading(false);
        let data = [];
        for (let z = 0; z < showCandidate.length; z++) {

            showCandidate[z]['job_id'] = job_Id;
            showCandidate[z]['interview_round_id'] = SelectedRadio.interview_round_id
            data.push(showCandidate[z]);
        }


        let emailResponse = await sendMailCandidate({
            data: data,
        });
        //PC_EM_08 -> condtion is checked for the API response Status code and respective toast is shown
        if (emailResponse.data.statusCode == 200) {

            setinsertToast(true);
            setToastColor('green');
            setToastPara('Email Delivery Successful');
            setToastValue('Success');
            setallCheck(false);
            let checkboxArray = new Array(gridData?.length).fill(false);
            setCheckArray(checkboxArray);
            setShowCandidate([]);
            candidateRecords.length == 0 && setHideBar(true);
        } else {
            setinsertToast(true);
            setToastColor('Red');
            setToastPara('Email Delivery Unsuccessful');
            setToastValue('Failure');
            candidateRecords.length == 0 && setHideBar(true);
            setallCheck(false);
            setShowCandidate([]);
            let checkboxArray = new Array(gridData?.length).fill(false);
            setCheckArray(checkboxArray);
        }
    };
    //export to excel

    const handleExportExcel = async () => {
        //debugger

        try {
            
            let exportToExcel = [
                [
                    "Candidate Name",
                    "Candidate ID",
                    "Email ID",
                    "Contact",
                    " Applied On",
                    "Status",
                    "Comments",
                    ...(SelectedRadio.stage !== "Screening" ? ["Email status", "Email Sent by"] : [])
                ],
            ];


            for (var i = 0; i < gridData.length; i++) {
                let val = [];
                val.push(
                    gridData[i].first_name + " " + gridData[i].last_name,
                    gridData[i].id,
                    gridData[i].email_id,
                    gridData[i].mobile_number,
                    gridData[i].created_at,
                    gridData[i].status,
                    gridData[i].status === 'Not Available' ? gridData[i].comments || '' : 'NA',
                    SelectedRadio.stage !== 'Screening' ? [
                        gridDataStatus[i]?.is_check == true ? 'Sent' : 'Pending',
                        gridDataStatus[i]?.is_check ? gridDataStatus[i]?.emp_name : '-'] : ""


                );
                exportToExcel.push(val);
            }

            let filename = "Candidate records"
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            let ws = XLSX.utils.aoa_to_sheet(exportToExcel);
            // const exportToCSV = (csvData, fileName) => {
            // const ws = XLSX.utils.(csvData);
            const wb = { Sheets: { 'View Log': ws }, SheetNames: ['View Log'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: fileType });
            ////debugger
            FileSaver.saveAs(data1, filename + fileExtension);
            setIsLoading(true);
        } catch (error) {
            throw error;
        }
    };

    const handleExportExcels = async () => {
        //debugger

        try {
            
            let exportToExcel = [
                [
                    "Candidate Name",
                    "Candidate ID",
                    "Job position",
                    "Email ID",
                    "Contact",
                    "Applied On",
                    "Status",
                    "Source",
                    "Interview Round",
                    "Offer Status",
                    ...(SelectedRadio.stage !== "Screening" ? ["Email status", "Email Sent by"] : [])
                ],
            ];


            for (var i = 0; i < gridData.length; i++) {
                let val = [];
                const appliedOnDate = new Date(gridData[i].created_at).toISOString().split('T')[0];

                val.push(
                    gridData[i].first_name + " " + gridData[i].last_name,
                    gridData[i].id,
                    gridData[i].job_title,
                    gridData[i].email_id,
                    gridData[i].mobile_number,
                    appliedOnDate,
                    gridData[i].status,
                    gridData[i].job_source_name,
                    gridData[i].interview_round_name,
                    gridData[i].experience,
                    gridData[i].offerletter_status || 'Not drafted',



                    SelectedRadio.stage !== 'Screening' ? [
                        gridDataStatus[i]?.is_check == true ? 'Sent' : 'Pending',
                        gridDataStatus[i]?.is_check ? gridDataStatus[i]?.emp_name : '-'] : ""


                );
                exportToExcel.push(val);
            }

            let filename = "Candidate"
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            let ws = XLSX.utils.aoa_to_sheet(exportToExcel);
            // const exportToCSV = (csvData, fileName) => {
            // const ws = XLSX.utils.(csvData);
            const wb = { Sheets: { 'View Log': ws }, SheetNames: ['View Log'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data1, filename + fileExtension);
            setIsLoading(true);
        } catch (error) {
            throw error;
        }
    };


    //Cancel click function
    let interviewCancelClick = () => {
        
        setInterviewData({
            ...scheduleObj,
            availabilityStatus: 'Available',
            title: '',
            meeting_details: '',
            interview_round_id: '',
            interview_date: '',
            start_time: [],
            end_time: [],
            time_interval: '',
            local_end_time: '',
            local_start_time: '',
            comments: ''
        });
        setTitleValidation('');
        setMeetingDetailsValidation('');
        setInterviewRoundValidation('');
        setInterviewersValidation('');
        setCandidatesValidation('');
        setDateValidation('');
        setStartTimeValidation('');
        setEndTimeValidation('');
        setTimeIntervalValidations('');
        setHideSchedule(true);
        setallCheck(false);
        setCommentsValidation('')
        let checkboxArray = new Array(gridData?.length).fill(false);
        setCheckArray(checkboxArray);
        setShowCandidate([]);
        setEmpId([]);
        setCandidateRecords([]);
        setHideBar(true)
    };

    // let handleChange = (e) => {
    //     let selectedValue = [];
    //     let attend = [];
    //     selectedValue = e;
    //     e?.map((data) => {
    //         attend.push(data.value);
    //     });
    //     setSelectedPeopleList(selectedValue);
    //     setEmp(attend);
    // };
    let handleChange = (e) => {
        
        let selectedValue = null;
        let attend = [];
        let arr = []

        if (e) {
            selectedValue = e;
            arr.push(selectedValue)
            attend.push(e.value);
        }
        if (Array.isArray(selectedValue)) {
            // If selectedValue is an array
            setSelectedPeopleList(selectedValue);
        }
        else {
            setSelectedPeopleList(arr);
        }
        setEmp(attend);
    };

    let onInterviewValue = (e) => {
        ;
        let istStartTime = '';
        let istEndTime = '';

        // First, handle the availability status change
        if (e.target.name === 'availabilityStatus') {
            const newAvailabilityStatus = e.target.value;
            setInterviewData(prevData => ({
                ...prevData,
                availabilityStatus: newAvailabilityStatus,
                availability: newAvailabilityStatus === 'Available'
            }));

            // Reset validations and fields based on availability status
            if (newAvailabilityStatus === 'Not Available') {
                setTitleValidation('');
                setMeetingDetailsValidation('');
                setDateValidation('');
                setStartTimeValidation('');
                setEndTimeValidation('');
                setTimeIntervalValidations('');
                // Reset fields that are not applicable for 'Not Available'
                setInterviewData(prevData => ({
                    ...prevData,
                    title: '',
                    meeting_details: '',
                    interview_date: '',
                    local_start_time: '',
                    local_end_time: '',
                    time_interval: ''
                }));
            } else {
                // Reset 'Not Available' specific fields
                setInterviewData(prevData => ({
                    ...prevData,
                    comments: ''
                }));
            }
            return; // Exit the function early as we've handled the availability change
        }


        if (e.target.id === 'interview_round_id') {
            const selectedOption = e.target.options[e.target.selectedIndex];
            const selectedRoundName = selectedOption.text;
            setInterviewData(prevData => ({
                ...prevData,
                interview_round_id: e.target.value,
                interview_round_name: selectedRoundName,
                time_interval: '' // Reset time interval when changing rounds
            }));
            setSelectedInterviewRound(selectedRoundName);
            setTimeIntervalValidations(''); // Reset validation message
            if(selectedRoundName == 'Group Discussion'){
                setRoundHidden(false)
            }
        }
    

        // Only proceed with other validations if the status is 'Available'
        if (interviewData.availabilityStatus === 'Available') {
            if (e.target.id === 'title' && e.target.value !== '') {
                setTitleValidation('');
            } else if (e.target.id === 'meeting_details' && e.target.value !== '') {
                setMeetingDetailsValidation('');
            } else if (e.target.id === 'interview_round_id' && e.target.value !== '') {
                setInterviewRoundValidation('');
            } else if (e.target.id === 'interview_date' && e.target.value !== '') {
                setDateValidation('');
            } else if (e.target.id == 'local_start_time' && e.target.value != '') {
                setStartTimeValidation('');
                let starttimevalue = e.target.value;
                let end = starttimevalue.split(':');

                var currentTime = new Date();

                let arr = currentTime.toString().split(' ');
                arr[4] = `${end[0]}:${end[1]}:00`;
                currentTime = new Date(arr.join(' '));

                var currentOffset = currentTime.getTimezoneOffset();

                var ISTOffset = 330; // IST offset UTC +5:30

                var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

                // ISTTime now represents the time in IST coordinates

                var hoursIST = ISTTime.getHours();
                var minutesIST = ISTTime.getMinutes();
                var formattedMinutesIST = String(minutesIST).padStart(2, '0');
                istStartTime = hoursIST + ':' + formattedMinutesIST;

                istStartTime = hoursIST + ':' + minutesIST;
                let targetvalue = e.target.value;
                let date = new Date();

                let dates = moment(date).format('YYYY-MM-DD');
                if (interviewData.interview_date == dates) {
                    let currentTime = new Date().toLocaleTimeString();

                    let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                    let temp = e.target.value.split(':');

                    if (temp[0] == '00') {
                        temp[0] = '24';

                        temp = temp.join(':');
                    }

                    if (temp < convertedTime) {
                        setStartTimeValidation('Valid Start Time is required');
                    } else {
                        setStartTimeValidation('');
                    }
                }
            }

            else if (e.target.id == 'local_end_time' && e.target.value != '') {
                setEndTimeValidation('');
                let endtimevalue = e.target.value;
                let end = endtimevalue.split(':');

                var currentTime = new Date();

                let arr = currentTime.toString().split(' ');
                arr[4] = `${end[0]}:${end[1]}:00`;
                currentTime = new Date(arr.join(' '));

                var currentOffset = currentTime.getTimezoneOffset();

                var ISTOffset = 330; // IST offset UTC +5:30

                var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

                // ISTTime now represents the time in IST coordinates

                var hoursIST = ISTTime.getHours();
                var minutesIST = ISTTime.getMinutes();
                var formattedEndMinutesIST = String(minutesIST).padStart(2, '0');
                istEndTime = hoursIST + ':' + formattedEndMinutesIST;
                istEndTime = hoursIST + ':' + minutesIST;

                let date = new Date();

                let dates = moment(date).format('YYYY-MM-DD');

                if (interviewData.interview_date == dates) {
                    let currentTime = new Date().toLocaleTimeString();
                    let convertedTime = moment(currentTime, 'hh:mm A').format('HH:mm');

                    let temp = e.target.value.split(':');

                    if (temp[0] == '00') {
                        temp[0] = '24';

                        temp = temp.join(':');
                    }

                    if (temp < convertedTime) {
                        setEndTimeValidation('Valid End Time is required');
                    } else {
                        setEndTimeValidation('');
                    }
                }
            }
            else if (e.target.id === 'time_interval') {
                if (e.target.value === '') {
                    setTimeIntervalValidations('Time Interval is required');
                } else {
                    setTimeIntervalValidations('');
                }
            }
        }

        // Handle comments for 'Not Available'
        if (e.target.id === 'comments') {
            //debugger
            setInterviewData(prevData => ({ ...prevData, comments: e.target.value }));
            setCommentsValidation('')
        }
        // Update the interviewData state
        if (e.target.id === 'local_end_time') {
            setInterviewData(prevData => ({ ...prevData, end_time: istEndTime, local_end_time: e.target.value }));
        } else if (e.target.id === 'local_start_time') {
            setInterviewData(prevData => ({ ...prevData, start_time: istStartTime, local_start_time: e.target.value }));
        } else if (e.target.id == 'interview_round_id') {
            const selectedOption = e.target.options[e.target.selectedIndex];
            setInterviewData(prevData => ({
                ...prevData,
                interview_round_id: e.target.value,
                interview_round_name: selectedOption.text
            }));
        }
        else {
            setInterviewData(prevData => ({ ...prevData, [e.target.id]: e.target.value }));
        }
    };
    /**
     * PS_CP_05 - PS_CP_11
     * Handle the show pop up onclick of the tataol count from the main grid.
     */
    const handleTotalCountClick = () => {

        setShowPopup(true);
    };


    // const filterValueChange = (event) => {
    //     const { name, value } = event.target;
    //     setFilterDataa(prevState => ({
    //         ...prevState,
    //         [name]: value
    //     }));
    // };

    let minDate = moment(new Date()).format('L');
    minDate = minDate.split('/')[2] + '-' + minDate.split('/')[0] + '-' + minDate.split('/')[1];
    //PC_HC_12

    // Insert the submitHold data
    let submitHold = async (value) => {
        let candiFresher = [];
        let candiExp = [];
        let emp_email = [];
        empId?.map((obj) => {
            if (obj[2] == 'Fresher') {
                candiFresher.push(obj[0]);
            } else {
                candiExp.push(obj[0]);
            }
            emp_email.push(obj[5]);
        });

        if (interchangeValidation() == true) {
            if (value == 'InterChange') {
                if (candiFresher?.length > 0) {
                    let resp = await postFresherInterchange({
                        job_id: interchangeData.job_id,
                        id: candiFresher,
                    });
                    if (interchangeData.checked == true) {
                        let content = {
                            Subject: `Job Matching your skillset`,
                            body: `<html lang="en">
    
                        <head>
                          <meta charset='utf-8'>
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <title>Invite User</title>
                        </head>
                        
                        <body>
                          <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                           <div style="background-color:#ffffff; width: 100%;">
                            <div style="padding: 15px 32px; background-color: #ffffff;">
                             <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                            </div>
                           </div>
                        
                           <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                           <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                            <h3 style=" font-size: 20px; color: #F29B10;">
                            Dear Candidate,
                            </h3>
                            <p style=" font-size: 16px; color: #0f0f0f;">
                            Hope your day is going great! <br/>
    
                            As you might be aware that we have openings for ${interchangeData.job_title} , we would like to move your profile to ${interchangeData.job_title} position as it matches the required skillset.  
                            
                            Please find this as an official notification for proceeding with the same! <br/><br/>
                            
                            We wish you the very best!  <br/><br/>
                            Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${interchangeData.job_id}">https://hivecandidate.avasoft.com?id=${interchangeData.job_id}</a> 
                          </p>
                          <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                           Yours Truly,
                           </p>
                          <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                           Team Avasoft
                           </p>
                           </div>
                          </div>
                          
                        </div>
                        </body>
                        </html>`,
                            to: emp_email,
                        };

                        sendMail(content);
                        setEmpId([]);
                        setRenderFlag(!renderFlag);
                    }
                }
                if (candiExp?.length > 0) {
                    let resp1 = await postExpInterchange({
                        job_id: interchangeData.job_id,
                        id: candiExp,
                    });
                    if (interchangeData.checked == true) {
                        let content = {
                            Subject: `Job Matching your skillset`,
                            body: `<html lang="en">

                    <head>
                      <meta charset='utf-8'>
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Invite User</title>
                    </head>
                    
                    <body>
                      <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                       <div style="background-color:#ffffff; width: 100%;">
                        <div style="padding: 15px 32px; background-color: #ffffff;">
                         <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                        </div>
                       </div>
                    
                       <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                       <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                        <h3 style=" font-size: 20px; color: #F29B10;">
                        Dear Candidate,
                        </h3>
                        <p style=" font-size: 16px; color: #0f0f0f;">
                        Hope your day is going great! <br/><br/>

                        As you might be aware that we have openings for ${interchangeData.job_title} , we would like to move your profile to ${interchangeData.job_title} position as it matches the required skillset.  
                        
                        Please find this as an official notification for proceeding with the same! <br/><br/>
                        
                        We wish you the very best!<br/><br/>
                        Please click in the following link:   <a href="https://hivecandidate.avasoft.com?id=${interchangeData.job_id}">https://hivecandidate.avasoft.com?id=${interchangeData.job_id}</a>
                      </p>
                      <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                       Yours Truly,
                       </p>
                      <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                       Team Avasoft
                       </p>
                       </div>
                      </div>
                      
                    </div>
                    </body>
                    </html>`,
                            to: emp_email,
                        };
                        sendMail(content);
                    }
                }
                setHideInterchange(true);
                setHideCandidate(true);
                setEmpId([]);
                setRenderFlag(!renderFlag);

                setCheckArray(checkboxArray);
            }
        }
        if (holdvalidation() == true) {
            if (value == 'Hold') {
                if (candiFresher?.length > 0) {
                    holdData.candidate_id = candiFresher;
                    let resp = await insertHoldCandidate(holdData);
                }
                if (candiExp?.length > 0) {
                    holdData.candidate_id = candiExp;
                    let resp = await insertHoldCandidate(holdData);
                }
                rejectOrBlockClick('Hold');
                setCheckArray(checkboxArray);
            }
            var holdCandidateObj = {
                candidate_id: '',
                job_id: '',
                email: '',
                // hold_until_duration: '',
                // hold_until_date: '',
                reason_for_hold: '',
            };
            setHoldData(holdCandidateObj);
            setEmpId([]);
            setRenderFlag(!renderFlag);
            candidateRecords.length == 0 && setHideBar(true);
            setHideCandidate(true);

            setCheckArray(checkboxArray);
        }
    };

    // const [availabilityStatusValidation, setAvailabilityStatusValidation] = useState('');

    return (
        <div className="body-bg">
            {/*Navigation TABS */}
            {/*Navigation TABS */}

            <div className="container-fluid p-2">
                <div className="row">
                    {/*jobs tab  */}
                    <div className="tab-content p-0" id="pills-tabContent">
                        <div className="tab-pane fade mt-4" id="jobs" role="tabpanel" aria-labelledby="#jobs">
                            1
                        </div>
                        {/*jobs tab  */}
                        {/*candidates tab  */}

                        <div className="tab-pane fade show active" id="candidate" role="tabpanel" aria-labelledby="#candidate">
                            <div className="col-md-12">
                                {insertToast ? (
                                    <EvaluationPopUp
                                        color={ToastColor}
                                        Page={'Success Insert'}
                                        Heading={ToastValue}
                                        Paragraph={ToastPara}
                                    />
                                ) : null}
                                <div className="d-flex justify-content-between mb-4">
                                    <div className="float-start" hidden={path == '/Recruitment' ? true : false}>
                                        <label className="regular-text font-14 me-4">Interviews</label>

                                        <div class="form-check d-inlineblock me-3">
                                            <input
                                                class="form-check-input custom-radio-btn"
                                                type="radio"
                                                name="interview-round"
                                                id="type-ALL"
                                                value="ALL"
                                                checked={SelectedRadio.stage == 'Screening'}
                                                onClick={(e) => {
                                                    setSelectedRadio({
                                                        ...SelectedRadio,
                                                        stage: 'Screening',
                                                        interview_round_id: '',
                                                        interview_round_name: '',
                                                    });
                                                    setHideBar(true);
                                                    setCandidateRecords([])
                                                    setShowCandidate([]);
                                                    setEmpId([]);
                                                    let checkboxArray = new Array(gridData?.length).fill(false);
                                                    setCheckArray(checkboxArray);
                                                    setallCheck(false);
                                                    setFilterData(filterObj);
                                                }}
                                            ></input>
                                            <label class="form-check-label regular-text font-12 personal-text-blue" for="type-ALL">
                                                ALL
                                            </label>
                                        </div>

                                        {bindInterview()}
                                    </div>

                                    <div className="ms-auto d-flex">
                                        <button
                                            hidden={path !== '/Recruitment/Jobs' ? true : false}
                                            className="btn hive-btn-outline me-4"
                                            onClick={() => {
                                                handleExportExcel();
                                            }}
                                        >
                                            Export to Excel
                                        </button>
                                        <div className="input-group flex-nowrap search-group me-3">
                                            <input
                                                type="search"
                                                className="form-control search-align "
                                                placeholder="Search"
                                                // PC_SC_2 useRef hook for search field
                                                ref={searchRef}
                                                // PC_SC_3 onKeyDown event triggers on clicking the enter
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13 && searchRef.current) {
                                                        // setSearchData(searchRef.current.value);
                                                        // handleSearch(searchRef.current.value)
                                                        path == '/Recruitment/Jobs'
                                                            ? SpecificJobSearch(searchRef.current.value)
                                                            : handleSearch(searchRef.current.value);
                                                    }
                                                }}
                                            />
                                            <button
                                                // PC_SC_4 onClick event triggers on clicking search icon
                                                className="input-group-text btn btn-search-custom"
                                                onClick={() => {
                                                    {
                                                        path == '/Recruitment/Jobs'
                                                            ? SpecificJobSearch(searchRef.current.value)
                                                            : handleSearch(searchRef.current.value);
                                                    }

                                                    // setSearchData(searchRef.current.value);
                                                }}
                                            >
                                                <img src="/Images/search-icon.svg" alt="search-icon" />
                                            </button>
                                        </div>
                                    </div>



                                    <div className="dropdown">
                                        <button
                                            className="advanced-filter-button me-3 medium-text"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            aria-expanded="false"
                                            onClick={() => setFilterShow(!filterShow)}
                                        >
                                            <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                            Filter
                                        </button>
                                        {filterShow && (
                                            <div
                                                className="dropdown-menu custom-dropdown px-3 advanced-filter-panel show"
                                            >
                                                {/* FILTER */}
                                                <div className="row">
                                                    <div className="col-md-12 py-2 border-0 mb-1">
                                                        <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                        <button
                                                            type="button"
                                                            className="btn-close float-end close-filter"
                                                            // onClick={()=>setFilterData(filterObj)}
                                                            onClick={() => setFilterShow(false)}
                                                        />
                                                    </div>
                                                    <div className="col-md-12 ">
                                                        <div className="row mb-3">
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                                    Status
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="status"
                                                                    value={FilterData.status} // This should be an array now
                                                                    onChange={filterValueChange}
                                                                    name="status"
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="InActive">InActive</option>
                                                                    <option value="Hold">Hold</option>
                                                                    <option value="Active">Active</option>
                                                                    <option value="Block">Block</option>
                                                                    <option value="On Hold">On Hold</option>
                                                                    <option value="Selected">Selected</option>
                                                                    {/* {SelectedRadio.stage == 'Screening' ? null : <option value="Selected">Selected</option>} */}
                                                                    <option value="Rejected">Rejected</option>
                                                                    <option value="Malpractice">Malpractice</option>
                                                                    <option value="NoShow">No Show</option>
                                                                    <option value="Delegate">Delegate</option>
                                                                    <option value="Scheduled">Scheduled</option>
                                                                    <option value="Reschedule">Reschedule</option>
                                                                    <option value="Not Available">Not Available</option>
                                                                </select>
                                                            </div>
                                                            {/* <div className="col-md-6 mb-3" hidden={path == '/Recruitment/Jobs' ? true : false}>
                                                            <label className="form-label hive-form-label" htmlFor="Domain">
                                                                Stage
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example2"
                                                                id="stage"
                                                                value={FilterData.stages}
                                                                onChange={filterValueChange}
                                                                name="stages"
                                                            >
                                                                <option value={''}>Select</option>
                                                                <option value={'Hire'}>Hire</option>
                                                                <option value={'Interviews'}>Interviews</option>
                                                                <option value={'Offer'}>Offer</option>
                                                                <option value={'Screening'}>Screening</option>
                                                                <option value={'Sourcing'}>Sourcing</option>
                                                            </select>
                                                        </div> */}
                                                            {/*PS_01 -- When user clicks on Filter Button*/}
                                                            {/*PS_18 - PS_21 -- When user selects the multiple values */}
                                                            {/* <div className="col-md-6 mb-3" hidden={path == '/Recruitment/Jobs' ? true : false}>
                                                            <label className="form-label hive-form-label" htmlFor="College">
                                                                College
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Select Colleges"
                                                                id="College"
                                                                value={FilterData.college_name}
                                                                onChange={handleCollegeChange}
                                                                name="college_name"
                                                            >                                                           
                                                                <option value="">Select</option>
                                                                {bindCollege()}
                                                                </select>
                                                                <div className="mt-2">
                                                                    {FilterData.college_name.map((collegeAbbr, index) => (
                                                                    <span key={index} className="badge bg-primary me-1 mb-1">
                                                                        {collegeAbbr}
                                                                        <button type="button" className="btn-close btn-close-white ms-1" aria-label="Remove"
                                                                            onClick={() => handleRemoveCollege(collegeAbbr)}></button>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                        </div> */}
                                                            <div className="col-md-6 mb-3" hidden={path == '/Recruitment/Jobs' ? true : false}>
                                                                <label className="form-label hive-form-label" htmlFor="College">
                                                                    College
                                                                </label>
                                                                <Select
                                                                    isMulti
                                                                    name="college_name"
                                                                    options={collegeDropdown.map(college => ({
                                                                        value: college.college_abbreviation,
                                                                        label: college.college_abbreviation
                                                                    }))}
                                                                    className="basic-multi-select"
                                                                    classNamePrefix="select"
                                                                    onChange={(selectedOptions) => {
                                                                        setFilterData({
                                                                            ...FilterData,
                                                                            college_name: selectedOptions.map(option => option.value)
                                                                        });
                                                                    }}
                                                                    value={FilterData.college_name.map(college => ({
                                                                        value: college,
                                                                        label: college
                                                                    }))}
                                                                />
                                                            </div>

                                                            <div
                                                                className="col-md-6 mb-3"
                                                                hidden={SelectedRadio.interview_round_name == 'Group Discussion' ? false : true}
                                                            >
                                                                <label className="form-label hive-form-label" htmlFor="Domain">
                                                                    Batch
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="batch"
                                                                    value={FilterData.batch_no}
                                                                    onChange={filterValueChange}
                                                                    name="batch_no"
                                                                >
                                                                    <option value={''}>Select</option>
                                                                    {bindFresherBatch()}
                                                                    {bindExpBatch()}
                                                                </select>
                                                            </div>
                                                            <div
                                                                className="col-md-6 mb-3"
                                                                hidden={SelectedRadio.stage == 'Screening' ? true : false}
                                                            >
                                                                <label className="form-label hive-form-label" htmlFor="Domain">
                                                                    Interviewer
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="interviewer"
                                                                    name="scheduled_by"
                                                                    onChange={filterValueChange}
                                                                    value={FilterData.scheduled_by}
                                                                >
                                                                    <option value={''}>Select</option>
                                                                    {bindFresherInterviewer()}
                                                                    {bindExpInterviewer()}
                                                                </select>
                                                            </div>
                                                            <div
                                                                className="col-md-6 mb-3 "
                                                                hidden={
                                                                    path !== '/Recruitment/Jobs' ||
                                                                        (path == '/Recruitment/Jobs' &&
                                                                            SelectedRadio.stage !== 'Screening' &&
                                                                            FinalRound == SelectedRadio.interview_round_id)
                                                                        ? false
                                                                        : true
                                                                }
                                                            >
                                                                <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                                    Offer Status
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="offerstatus"
                                                                    name="offerletter_status"
                                                                    value={FilterData.offerletter_status}
                                                                    onChange={filterValueChange}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Not Drafted">Not Drafted</option>
                                                                    <option value="Offer Drafted">Offer Drafted</option>

                                                                    <option value="Offer Send">Offer Send</option>
                                                                    <option value="Offer Accepted">Offer Accepted</option>
                                                                    <option value="Offer Rejected">Offer Rejected</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-md-6 mb-3" hidden={path == '/Recruitment/Jobs' ? true : false}>
                                                                <label className="form-label hive-form-label" htmlFor="job_source_name">
                                                                    Source
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="job_source_name"
                                                                    name="job_source_name"
                                                                    value={FilterData.job_source_name}
                                                                    onChange={filterValueChange}
                                                                >
                                                                    <option value={''}>Select</option>
                                                                    {bindInterviewSource()}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-6 mb-3" hidden={path == '/Recruitment/Jobs' ? true : false}>
                                                                <label className="form-label hive-form-label" htmlFor="Domain">
                                                                    Job Position
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="jobId"
                                                                    name="jobId"
                                                                    value={FilterData.jobId}
                                                                    onChange={filterValueChange}
                                                                >
                                                                    <option value={''}>Select</option>
                                                                    {/*  <option value={''}>new App Test</option>
                                                            <option value={''}>Test job</option>
                                                            <option value={''}>Dev new Job</option> */}
                                                                    {bindJobPosition()}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-6 mb-3" hidden={path == '/Recruitment/Jobs' ? true : false}>
                                                                <label className="form-label hive-form-label" htmlFor="Domain">
                                                                    Interview Round
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="interview_round_name"
                                                                    name="interview_round_name"
                                                                    value={FilterData.interview_round_name}
                                                                    onChange={filterValueChange}
                                                                >
                                                                    <option value="" onChange={filterValueChange}>
                                                                        Select
                                                                    </option>
                                                                    <option value="Group Discussion">GD</option>
                                                                    <option value="Technical Discussion">TD</option>
                                                                    <option value="Avasoft Final Round">AFR</option>
                                                                    <option value="HR Discussion">HD</option>
                                                                    <option value="Avasoft Final Meeting">AFM</option>
                                                                </select>
                                                            </div>
                                                            {/* <div className="col-md-6 mb-3" hidden={path == '/Recruitment/Jobs' ? true : false}>
                                                            <label className="form-label hive-form-label" htmlFor="Domain">
                                                                Experience
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example2"
                                                                id="jobId"
                                                                name="experience"
                                                                value={FilterData.experience}
                                                                onChange={filterValueChange}
                                                            >
                                                                <option value="" onChange={filterValueChange}>
                                                                    Select
                                                                </option>
                                                                <option value="Fresher">Fresher</option>
                                                                <option value="Experience">Experience</option>
                                                            </select>
                                                        </div> */}
                                                        </div>
                                                        <div className="col-md-12 pb-2 border-0 ">
                                                            <span className="font-14 semibold-text filter-title">Date Range</span>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="fromrange">
                                                                    From
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="fromDate"
                                                                    name="fromDate"
                                                                    value={FilterData.fromDate}
                                                                    onChange={filterValueChange}
                                                                    max={FilterData.toDate}
                                                                />
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="forange">
                                                                    To
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control hive-form-control"
                                                                    id="toDate"
                                                                    name="toDate"
                                                                    min={FilterData.fromDate}
                                                                    value={FilterData.toDate}
                                                                    onChange={filterValueChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 my-3 d-flex justify-content-end">
                                                        <button
                                                            className="btn hive-btn-secondary me-3"
                                                            onClick={() => {
                                                                
                                                                clearFilter();
                                                            }}
                                                        >
                                                            Clear
                                                        </button>
                                                        {/*PS_22 - PS_23 -- When User clicks on apply filter button*/}
                                                        <button
                                                            className="btn hive-btn-primary"
                                                            onClick={() => {
                                                                setFilterShow(false);
                                                                applyFilter(FilterData);
                                                                setCurrentPage(0)
                                                            }}
                                                        >
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* END OF FILTER */}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <button
                                    className="btn hive-btn-outline me-3" hidden={path == '/Recruitment/Jobs' ? true : false}
                                    style={{
                                        position: 'relative',
                                        top: '-63px',
                                        right: '10px',
                                        left: '959px',
                                        padding: '5px 10px',

                                    }}

                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    onClick={(e) => handleExportExcels(e)}
                                >
                                    Export to Excel
                                </button>

                                <div className="table-responsive rounded-3">
                                    <table className="table bg-white hive-recruitment-grid table-borderless ">
                                        <thead className="hive-table-head ">
                                            {/* PC_RC_35 added conditions using hidden attribute to hide the table columns for the respective grids */}
                                            <tr>
                                                {gridData?.length !== 0 ? (
                                                    <th className="hive-recruitement-header-th">
                                                        <input
                                                            className="form-check-input mt-0 recruitemt-input-checkbox"
                                                            type="checkbox"
                                                            checked={allCheck}
                                                            onChange={(e) => handleCheckbox(e, '', 'all')}
                                                            ref={Refer}
                                                        />
                                                    </th>
                                                ) : null}
                                                <th className="bold-text font-12 hive-recruitement-header-th">
                                                    Candidate Name
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="first_name-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.first_name === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            //PC_ST_2 onclick event triggers on clicking sort ascending icon

                                                            onClick={(e) => {
                                                                {
                                                                    setCurrentPage(0)
                                                                    // if(FilterData!="" || FilterData!=null)
                                                                    // {
                                                                    //     handleFilteredSort(gridData,SortData)
                                                                    // }
                                                                    // else{
                                                                    {
                                                                        path == '/Recruitment/Jobs'
                                                                            ? setSortData({ column_name: 'first_name', order_type: 'asc' })
                                                                            : sortIconClick(e, 't1');
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="first_name-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.first_name === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            //PC_ST_8 onclick event triggers on clicking the sort descending icon

                                                            onClick={(e) => {
                                                                setCurrentPage(0)
                                                                // if(FilterData!="" || FilterData!=null)
                                                                //     {
                                                                //         handleFilteredSort(gridData,SortData)
                                                                //     }
                                                                //     else
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'first_name', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12 hive-recruitement-header-th">
                                                    Candidate ID
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="id-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.id === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                setCurrentPage(0)
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'id', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="id-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.id === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                setCurrentPage(0)
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'id', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={path == '/Recruitment/Jobs' ? true : false}
                                                >
                                                    Job Position
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="job_title-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.job_title === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'job_id', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="job_title-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.job_title === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'job_id', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={SelectedRadio.interview_round_name == 'Group Discussion' ? false : true}
                                                >
                                                    Batch
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="batch_no-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.batch_no === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'batch_no', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="batch_no-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.batch_no === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'batch_no', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={SelectedRadio.stage == 'Screening' ? true : false}
                                                >
                                                    Interviewer
                                                    {/* <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="scheduled_by-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.scheduled_by === 'desc'
                                                                    ? false
                                                                    : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'scheduled_by', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="scheduled_by-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.scheduled_by === 'asc'
                                                                    ? false
                                                                    : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'scheduled_by', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span> */}
                                                </th>
                                                <th className="bold-text font-12 hive-recruitement-header-th">Email ID</th>
                                                <th className="bold-text font-12 hive-recruitement-header-th">Contact #</th>
                                                <th className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={path == '/Recruitment/Jobs' ? false : true}
                                                >Resume</th>
                                                <th className="bold-text font-12 hive-recruitement-header-th">
                                                    Applied On
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="created_at-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.created_at === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'created_at', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="created_at-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.created_at === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'created_at', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                {/* <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={path == '/Recruitment/Jobs' ? true : false}
                                                >
                                                    Stages
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="stages-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.stages === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'stages', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="stages-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.stages === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'stage', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th> */}
                                                <th className="bold-text font-12 hive-recruitement-header-th">
                                                    Status
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="status-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.status === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'status', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="status-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.status === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'status', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={path == '/Recruitment/Jobs' ? true : false}
                                                >
                                                    Source
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="job_source_name-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.job_source_name === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'job_source_name', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="job_source_name-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.job_source_name === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'job_source_name', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={path == '/Recruitment/Jobs' ? true : false}
                                                >
                                                    Interview Round
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="interview_round_name-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.interview_round_name === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'interview_round_name', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="interview_round_name-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.interview_round_name === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'interview_round_name', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>
                                                {/* <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={path == '/Recruitment/Jobs' ? true : false}
                                                >
                                                    Experience
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="experience-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.experience === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'experience', order_type: 'asc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="experience-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.experience === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({ column_name: 'experience', order_type: 'desc' })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th> */}
                                                <th class="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={
                                                        path !== '/Recruitment/Jobs' ||
                                                            (path == '/Recruitment/Jobs' &&
                                                                SelectedRadio.stage == 'Screening')
                                                            ? true
                                                            : false
                                                    }>

                                                    Email status

                                                </th>


                                                <th class="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={
                                                        path !== '/Recruitment/Jobs' ||
                                                            (path == '/Recruitment/Jobs' &&
                                                                SelectedRadio.stage == 'Screening')
                                                            ? true
                                                            : false
                                                    }
                                                >

                                                    Email sent by

                                                </th>

                                                <th
                                                    className="bold-text font-12 hive-recruitement-header-th"
                                                    hidden={
                                                        path !== '/Recruitment/Jobs' ||
                                                            (path == '/Recruitment/Jobs' &&
                                                                SelectedRadio.stage !== 'Screening' &&
                                                                FinalRound == SelectedRadio.interview_round_id)
                                                            ? false
                                                            : true
                                                    }
                                                >
                                                    Offer Status
                                                    <span className="ps-2">
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort"
                                                            id="offerletter_status-asc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'desc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.offerletter_status === 'desc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({
                                                                            column_name: 'offerletter_status',
                                                                            order_type: 'asc',
                                                                        })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                        <img
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort sort-rotate"
                                                            id="offerletter_status-desc"
                                                            hidden={
                                                                path === '/Recruitment/Jobs'
                                                                    ? SortData.order_type === 'asc'
                                                                        ? false
                                                                        : true
                                                                    : hideSortIcon.offerletter_status === 'asc'
                                                                        ? false
                                                                        : true
                                                            }
                                                            onClick={(e) => {
                                                                {
                                                                    path == '/Recruitment/Jobs'
                                                                        ? setSortData({
                                                                            column_name: 'offerletter_status',
                                                                            order_type: 'desc',
                                                                        })
                                                                        : sortIconClick(e, 't1');
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>{bindGridData()}</tbody>
                                    </table>
                                </div>
                            </div>
                            {showPopup ? (
                                <CandidatePopupGrid
                                    candidateRecords={candidateRecords}
                                    gridData={gridData}
                                    checkArray={checkArray}
                                    onClose={() => setShowPopup(false)}
                                    setallCheck={setallCheck}
                                    setCheckArray={setCheckArray}
                                    handleCheckbox={handleCheckbox}
                                    bindGridData={bindGridData}
                                    setCheckBoxCount={setCheckBoxCount}
                                    setHideBar={setHideBar}
                                    setCandidateRecords={setCandidateRecords}
                                    empId={empId}
                                    setEmpid={setEmpId}
                                    gridDataStatus={gridDataStatus}
                                    SelectedRadio={SelectedRadio}
                                    arrStatusStore={arrStatusStore}
                                />

                            ) : <></>}

                            {/** ACTION BAR **/}
                            <div className="container-fluid" hidden={hideBar == true ? true : false}>
                                <div className="row justify-content-center">
                                    <div className="col-md-10 text-center d-flex align-items-center justify-content-between Todo-Strip-bg Strip-bot candidate-actions">
                                        <img
                                            onClick={() => {
                                                setHideBar(true);
                                                setCheckArray(checkboxArray);
                                                setallCheck(false);
                                                setShowCandidate([]);
                                                setEmpId([]);
                                                setCandidateRecords([]);
                                            }}
                                            src="/Images/Todo-stripe-close.svg"
                                            alt="Closebutton"
                                            className="cursor-pointer p-4"
                                        />
                                        <p className="todo-Font-White mb-0" >
                                            <span
                                                className="todo-count font-18 semibold-text me-2"
                                                style={{ display: 'inline-block', cursor: 'pointer' }}
                                                onClick={handleTotalCountClick}
                                            >
                                                {candidateRecords.length}
                                            </span>
                                            Item Selected
                                        </p>
                                        <div class="dropdown">
                                            <button
                                                class="btn todo-btn dropdownButton"
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <img src="/Images/recruit-threedots.svg"></img> More Actions
                                            </button>
                                            <ul
                                                class={
                                                    blockflag == false && unblockflag == false && holdflag == false && unholdflag == false
                                                        ? 'dropdown-menu dropdownButton-list single'
                                                        : unblockflag == true
                                                            ? 'dropdown-menu dropdownButton-list single'
                                                            : 'dropdown-menu dropdownButton-list double'
                                                }
                                                aria-labelledby="dropdownMenuButton"
                                            >
                                                {blockflag && (
                                                    <li
                                                        onClick={() => {
                                                            rejectOrBlockClick('Block');
                                                            setHideBar(true)
                                                        }}
                                                    >
                                                        <a class="dropdown-item" href="#">
                                                            <img src="/Images/recruit-block.svg" className="me-3"></img>Block
                                                        </a>
                                                    </li>
                                                )}

                                                {unblockflag && (
                                                    <li
                                                        onClick={() => {
                                                            rejectOrBlockClick('Active');
                                                            setHideBar(true)
                                                        }}
                                                    >
                                                        <a class="dropdown-item" href="#">
                                                            <img src="/Images/recruit-block.svg" className="me-3" />
                                                            UnBlock
                                                        </a>
                                                    </li>
                                                )}

                                                {holdflag && (
                                                    <li
                                                        onClick={() => {
                                                            setHideCandidate(false);
                                                            candidateRecords.length == 0 && setHideBar(true);
                                                            setallCheck(false);
                                                            bindcandidatename();
                                                        }}
                                                    >
                                                        <a class="dropdown-item" href="#">
                                                            <img src="/Images/recruit-hold.svg" className="me-3"></img>Hold
                                                        </a>
                                                    </li>
                                                )}

                                                {unholdflag && (
                                                    <li
                                                        onClick={() => {
                                                            // setHideCandidate(false);
                                                            candidateRecords.length == 0 && setHideBar(true);
                                                            setallCheck(false);
                                                            rejectOrBlockClick('Active');
                                                        }}
                                                    >
                                                        <a class="dropdown-item" href="#">
                                                            <img src="/Images/recruit-hold.svg" className="me-3"></img>UnHold
                                                        </a>
                                                    </li>
                                                )}

                                                {/* <li
                                                    onClick={() => {
                                                        rejectOrBlockClick('Rejected');
                                                    }}
                                                >
                                                    <a class="dropdown-item" href="#">
                                                        <img src="/Images/recruit-reject.svg" className="me-3"></img>Reject
                                                    </a>
                                                </li> */}
                                            </ul>
                                        </div>

                                        {path == '/Recruitment/Jobs' ? (
                                            <button
                                                className="btn todo-btn font-14 semibold-text"
                                                onClick={() => {
                                                    setHideInterchange(false);
                                                    candidateRecords.length == 0 && setHideBar(true);
                                                    setallCheck(false);
                                                    bindcandidatename();
                                                }}
                                            >
                                                <img src="/Images/recruit-interchange.svg" className="me-3" />
                                                Interchange
                                            </button>
                                        ) : (
                                            <></>
                                        )}

                                        {actionBarGenerateOffer == false && path !== '/Recruitment/Jobs' ? (
                                            <button
                                                hidden={actionBarGenerateOffer == true && path !== '/Recruitment/Jobs' ? true : false}
                                                onClick={() => {
                                                    window.location.href = `/Recruitment/OfferLetter`;
                                                }}
                                                className="btn todo-btn font-14 semibold-text"
                                            >
                                                <img src="/Images/recruit-sendOffer.svg" className="me-3" />
                                                Send Offer
                                            </button>
                                        ) : null}

                                        {/* <button
                                            className="btn todo-btn font-14 semibold-text"
                                        hidden={path == '/Recruitment/Jobs' ? false : true}
                                        onClick={() => {
                                            setHideInterchange(false);
                                            setHideBar(true);
                                            setallCheck(false);
                                        }}
                                        >
                                             <img src="/Images/recruit-interchange.svg" className="me-3" />
                                             Interchange
                                         </button> */}
                                        {/* Schedule Button */}
                                        <button
                                            className="btn todo-btn font-14 semibold-text"
                                            hidden={path == '/Recruitment/Jobs' ? false : true}
                                            onClick={async () => {
                                                // setInterviewData(prevData => ({
                                                //     ...prevData,
                                                //     availability: true // Always set availability to true
                                                // }));
                                                setHideSchedule(false);
                                                candidateRecords.length == 0 && setHideBar(true);
                                                bindcandidatename();
                                                setIsReschedule(candidateRecords.some(record => record.status === 'Reschedule'));
                                                if (SelectedRadio.stage == 'Screening') {
                                                    
                                                    let batchResponse = await getBatchDetails({
                                                        job_id: job_Id,
                                                        experience: exp,
                                                    });
                                                    let val;
                                                    ;
                                                    //PC_BI_07 -> condition for statusCode is checked and batchNo is set stated
                                                    if (batchResponse.data.statusCode == 200) {
                                                        if (batchResponse?.data?.data?.length == 0) {
                                                            val = 0;
                                                        } else {
                                                            val = batchResponse?.data?.data[0]?.batch_no;
                                                        }
                                                        val++;
                                                        setBatchNo(val);
                                                    }
                                                    setIntervalHidden(true);
                                                    loadInterviews();
                                                }
                                                //PC_BI_09 -> Else the round is not Group Discussion the Time Interval field is shown in the form
                                                else {
                                                    setInterviewData({
                                                        ...interviewData,
                                                        interview_round_id: '',
                                                        interview_round_name: '',
                                                    });
                                                    // loadInterviews(SelectedRadio.interview_round_id);
                                                    setIntervalHidden(false);
                                                }
                                            }}
                                        >
                                            <img src="/Images/recruit-schedule.svg" className="me-3" />
                                            {candidateRecords.some(record => record.status === 'Reschedule') ? 'Reschedule' : 'Schedule'}
                                        </button>
                                        {/* Send Email Button */}
                                        {SelectedRadio.stage !== 'Screening' ? (
                                            <button
                                                className="btn todo-btn font-14 semibold-text"
                                                hidden={path == '/Recruitment/Jobs' ? false : true}
                                                onClick={() => {
                                                    bindcandidatename();
                                                    //PC_EM_02 -> onclick of Send Email the confirmation pop is shown to sen email
                                                    setConfirmationContainer(false);
                                                    setPopUp('Send Email');
                                                }}
                                            >
                                                <img src="/Images/recruit-sendEmail.svg" className="me-3" />
                                                Send Email
                                            </button>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*candidates tab  */}
                    </div>
                </div>

                {/* {path == '/Recruitment/Jobs' ? (
                    <div className="text-center mb-3">
                        <button
                            className="btn show-more-btn"
                            hidden={CurrentPage >= totalPage}
                            onClick={() => {
                                setCurrentPage((PrevPage) => PrevPage + 20);
                            }}
                        >
                            show more
                        </button>
                    </div>
                ) : (
                    gridDataCount > loadmore + 10 && (
                        <div className="text-center mb-3">
                            <button
                                className="btn show-more-btn"
                                onClick={() => {
                                    loadMore();
                                }}
                            >
                                show more
                            </button>
                        </div>
                    )
                )} */}
                <div >
                    <p># of Records : {gridData.length} out of {gridDataCount}</p>
                </div>
                {path == '/Recruitment/Jobs' && gridDataCount > CurrentPage + 20 ? (
                    <div className="text-center mb-3">
                        <button
                            className="btn show-more-btn"
                            hidden={CurrentPage >= totalPage}
                            onClick={() => {
                                setCurrentPage((PrevPage) => PrevPage + 20);
                            }}
                        >
                            show more
                        </button>
                    </div>
                ) : <></>}

                {path !== '/Recruitment/Jobs' && gridDataCount > gridData.length ? (
                    <div className="text-center mb-3">
                        <button
                            className="btn show-more-btn"
                            onClick={() => {
                                loadMore();
                            }}
                        >
                            show more
                        </button>
                    </div>
                ) : <></>}
                {/* {gridDataCount */}



                {/* {gridDataCount > loadmore + 10 ? (
                    <div className="text-center mb-3">
                        <button
                            className="btn show-more-btn"
                            // hidden
                            onClick={() => {
                                loadMore();
                            }}
                        >
                            {' '}
                            show more
                        </button>
                    </div>
                ) : null} */}
            </div>

            {/* Confirmation Pop Up */}
            <div className="Failure-PopUp pop-bg" hidden={confirmationContainer == true ? true : false}>
                <div className="modal-dialog goal-popup email-conf-popup modal-dialog-centered">
                    <div className="modal-content px-2 pt-5 pb-3">
                        <button
                            type="button"
                            className="btn-close email-conf-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                            id="confirmation-pop"
                            onClick={(e) => {
                                cancelClick(e.target.id);
                            }}
                        />
                        <div className="modal-body text-center px-5 py-4">
                            <p className="bold-text font-18 text-blue mb-5">Are you sure, you want to {popUp}? </p>

                            <div className="text-center d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="btn hive-btn-secondary bold-text font-14 me-3"
                                    onClick={(e) => {
                                        cancelClick(e.target.id);
                                    }}
                                    id="confirmation-pop"
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn hive-btn-primary bold-text font-14"
                                    type="submit"
                                    data-bs-target="#candidate"
                                    onClick={() => {
                                        
                                        {
                                            if (popUp === 'Schedule Interview' || popUp === 'Reschedule Interview' || popUp == 'Mark as Not Available') {
                                                // Update interviewData based on popUp value
                                                setInterviewData(prevData => ({
                                                    ...prevData,
                                                    schedule: popUp === 'Schedule Interview' ? 'Schedule' : 'Reschedule'
                                                }));

                                                scheduleInterviewClick(); // Use the same click handler for both scheduling and rescheduling
                                            } else {
                                                onEmailSchedule();
                                            }
                                        }
                                        if (popUp !== 'Schedule Interview') {
                                            setIsLoading(false);
                                        }
                                        setConfirmationContainer(true);
                                        bindcandidatename();
                                    }}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*HOLD CANDIDATES */}
            <div hidden={hideCandidate} className="body-bg">
                <div className="container-fluid ">
                    <div className="row justify-content-center">
                        <div className="hold-candidate" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                            <div className="offcanvas-header mb-4">
                                <h5 className="mb-0 bold-text font-18 hold-candidates-header-color">Hold Candidate(s)</h5>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setHideCandidate(true);
                                        cancelClick('Hold');
                                        setHoldData(holdCandidateObj);
                                        setShowCandidate([]);
                                        setEmpId([]);
                                    }}
                                    className="btn-close"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="offcanvas-body">
                                {/* <div className="col-md-12 mb-3">
                                <label className="form-label hive-form-label" htmlFor="candidate">
                                    Candidate(s)<span className="hive-form-mandatory">*</span>
                                </label>

                                <Select
                                            className="dropdown"
                                            name="candidates"
                                            id="candidates"
                                            maxMenuHeight={150}
                                            placeholder="Select attendees"
                                            value={showCandidate}
                                            options={showCandidate}
                                            isMulti
                                            // isClearable
                                        />
                                <span style={{ color: 'red' }}>{candidatesValidation}</span>

                            </div> */}
                                <div className="col-md-12 mb-3">
                                    <label className="form-label hive-form-label" htmlFor="candidate">
                                        Candidate(s)
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    {/* <select className="form-select hive-form-select regular-text custom-textfield" onChange={onInterviewValue} id="candidate">
                                        <option value={""}>Select</option>
                                   </select> */}
                                    {/* candidate email field */}
                                    <Select
                                        className="dropdown"
                                        name="candidates"
                                        id="candidates"
                                        maxMenuHeight={150}
                                        placeholder="Select attendees"
                                        value={showCandidate}
                                        // options={showCandidate}
                                        isMulti
                                        isDisabled
                                    // isClearable
                                    />
                                    <span style={{ color: 'red' }}>{candidatesValidation}</span>
                                </div>
                                <div className="col-md-12 ">
                                    <label className="form-label hive-form-label hold-candidates-header-color mb-2" htmlFor="hold-reason">
                                        Reason for Holding Candidate(s)
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        className="form-control regular-text custom-comment-box custom-textfield hive-form-control"
                                        onChange={(e) => {
                                            onValueChange('Description', e);
                                        }}
                                        id="reason_for_hold"
                                        rows={6}
                                        value={holdData.reason_for_hold}
                                        placeholder="Description"
                                        maxLength={225}
                                    />
                                    <span style={{ color: 'red' }}>{holdErrData.reason_for_hold}</span>
                                </div>
                                <div className="col-md-12 d-flex justify-content-end hold-candidates-spacing">
                                    <button
                                        className="btn hive-btn-secondary me-2"
                                        onClick={() => {
                                            setHideCandidate(true);
                                            cancelClick('Hold');
                                            setHoldData(holdCandidateObj);
                                            setShowCandidate([]);
                                            setEmpId([]);
                                            setCandidateRecords([]);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button className="btn hive-btn-primary" onClick={() => submitHold('Hold')}>
                                        Save
                                    </button>
                                </div>
                            </div>
                            {/*offcanvas body ends here*/}
                        </div>
                    </div>
                </div>
            </div>
            {/*HOLD CANDIDATE ENDS HERE*/}


            {/* SCHEDULE STARTS HERE */}
            <div hidden={hideSchedule} className="body-bg">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="hold-candidate">
                            <div className="offcanvas-header mb-4">
                                <h5 className="mb-0 bold-text font-18 schedule-interview-header-color">
                                    {isReschedule ? 'Reschedule Interview' : 'Schedule Interview'}
                                    <span>{SelectedRadio.stage == 'Screening' ? `Batch-${batchNo}` : null} </span>
                                </h5>
                                <button
                                    onClick={() => {
                                        interviewCancelClick();
                                        setEmpId([]);
                                        setShowCandidate([]);
                                        setIsReschedule(false);
                                    }}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="offcanvas-body">
                                <div className="row align-items-end">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label hive-form-label">
                                            Candidate's Availability<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id="availableRadio"
                                                    name="availabilityStatus"
                                                    value="Available"
                                                    checked={interviewData.availabilityStatus === "Available"}
                                                    onChange={(e) => onInterviewValue(e)}
                                                />
                                                <label className="form-check-label" htmlFor="availableRadio">Available</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id="notAvailableRadio"
                                                    name="availabilityStatus"
                                                    value="Not Available"
                                                    checked={interviewData.availabilityStatus === "Not Available"}
                                                    onChange={(e) => onInterviewValue(e)}
                                                />
                                                <label className="form-check-label" htmlFor="notAvailableRadio">Not Available</label>
                                            </div>
                                        </div>
                                        <span style={{ color: 'red' }}>{availabilityStatusValidation}</span>
                                    </div>

                                    {interviewData.availabilityStatus === "Not Available" ? (
                                        <>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="interview_round_id">
                                                    Select Interview Round <span className="hive-form-mandatory">*</span>
                                                </label>
                                                <select
                                                    className="form-select hive-form-select regular-text custom-textfield"
                                                    id="interview_round_id"
                                                    onChange={(e) => onInterviewValue(e)}
                                                    value={interviewData.interview_round_id}
                                                >
                                                    <option value="">Select</option>
                                                    {bindInterviewRound()}
                                                </select>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="comments">
                                                    Comments
                                                </label>
                                                <textarea
                                                    className="form-control hive-form-control custom-textfield schedule-interview-commentbox regular-text"
                                                    onChange={(e) => onInterviewValue(e)}
                                                    value={interviewData.comments}
                                                    placeholder="Enter comments"
                                                    id="comments"
                                                />
                                                <span style={{ color: 'red' }}>{commentsValidation}</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="title">
                                                    Title<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control hive-form-control custom-textfield regular-text"
                                                    onChange={(e) => onInterviewValue(e)}
                                                    id="title"
                                                    value={interviewData.title}
                                                    placeholder="Enter Title"
                                                />
                                                <span style={{ color: 'red' }}>{titleValidation}</span>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="meeting-details">
                                                    Meeting Details
                                                </label>
                                                <textarea
                                                    className="form-control hive-form-control custom-textfield schedule-interview-commentbox regular-text"
                                                    onChange={(e) => onInterviewValue(e)}
                                                    value={interviewData.meeting_details}
                                                    placeholder="Enter Meeting details"
                                                    id="meeting_details"
                                                />
                                                <span style={{ color: 'red' }}>{meetingDetailsValidation}</span>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="interview-round">
                                                    Select Interview Round
                                                    <span className="hive-form-mandatory">*</span>
                                                </label>
                                                <select
                                                    className="form-select hive-form-select regular-text custom-textfield"
                                                    id="interview_round_id"
                                                    onChange={(e) => onInterviewValue(e)}
                                                    // disabled={SelectedRadio.stage == 'Screening' ? true : false}
                                                    value={interviewData.interview_round_id}
                                                >
                                                    <option value={''}>Select</option>
                                                    {bindInterviewRound()}
                                                </select>
                                                <span style={{ color: 'red' }}>{interviewRoundValidation}</span>
                                            </div>
                                            <div className="col-md-8 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="interviewer">
                                                    Interviewer(s)
                                                    <span className="hive-form-mandatory">*</span>
                                                </label>
                                                <Select
                                                    className="dropdown"
                                                    name="interviewer"
                                                    maxMenuHeight={150}
                                                    placeholder="Select Interviewers"
                                                    value={selectedPeopleList}
                                                    options={showEmployee}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                    }}
                                                    isClearable
                                                />
                                                <span style={{ color: 'red' }}>{interviewerValidation}</span>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="candidate">
                                                    Candidate(s)
                                                    <span className="hive-form-mandatory">*</span>
                                                </label>
                                                <Select
                                                    className="dropdown"
                                                    name="candidates"
                                                    id="candidates"
                                                    maxMenuHeight={150}
                                                    placeholder="Select attendees"
                                                    value={showCandidate}
                                                    options={showCandidate}
                                                    isMulti
                                                    isDisabled
                                                />
                                                <span style={{ color: 'red' }}>{candidatesValidation}</span>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="date">
                                                    Date<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    min={minDate}
                                                    className="form-control hive-form-control custom-textfield regular-text"
                                                    onChange={(e) => {
                                                        onInterviewValue(e);
                                                    }}
                                                    id="interview_date"
                                                    value={moment(interviewData.interview_date).format('YYYY-MM-DD')}
                                                />
                                                <span style={{ color: 'red' }}>{dateValidation}</span>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="s-time">
                                                    Start Time<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    onChange={(e) => {
                                                        onInterviewValue(e);
                                                    }}
                                                    value={interviewData.local_start_time}
                                                    className=" font-14 regular-text form-select hive-form-select image-none custom-textfield"
                                                    id="local_start_time"
                                                    type="time"
                                                />
                                                <span style={{ color: 'red' }}>{startTimeValidation}</span>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="e-time">
                                                    End Time<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    onChange={(e) => {
                                                        onInterviewValue(e);
                                                    }}
                                                    value={interviewData.local_end_time}
                                                    min={interviewData.start_time}
                                                    className=" font-14 regular-text form-select hive-form-select image-none custom-textfield"
                                                    id="local_end_time"
                                                    type="time"
                                                />
                                                <span style={{ color: 'red' }}>{endTimeValidation}</span>
                                            </div>
                                            {/* <div className="col-md-3 mb-3" hidden={roundHidden}> */}
                                            <div className="col-md-3 mb-3" hidden={!interviewData.interview_round_id || interviewData.interview_round_name === 'Group Discussion'}>
                                            <label className="form-label hive-form-label" htmlFor="e-time">
                                                    Time Interval<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <select
                                                    className="form-select hive-form-select regular-text custom-textfield"
                                                    id="time_interval"
                                                    onChange={(e) => {
                                                        onInterviewValue(e);
                                                    }}
                                                    value={interviewData.time_interval}
                                                >
                                                    <option value={''}>Select</option>
                                                    <option value={'10'}>10 Mins</option>
                                                    <option value={'15'}>15 Mins</option>
                                                    <option value={'20'}>20 Mins</option>
                                                    <option value={'30'}>30 Mins</option>
                                                    <option value={'45'}>45 Mins</option>
                                                    <option value={'60'}>60 Mins</option>
                                                </select>
                                                <span style={{ color: 'red' }}>{timeIntervalValidations}</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="col-md-12 d-flex justify-content-end mt-5">
                                    <button
                                        className="btn hive-btn-secondary me-2"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                        onClick={() => {
                                            interviewCancelClick();
                                            setShowCandidate([]);
                                            setEmpId([]);
                                            setIsReschedule(false);
                                            setCandidateRecords([]);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn hive-btn-primary"
                                        onClick={() => {
                                            schedule();
                                        }}
                                    >
                                        {interviewData.availabilityStatus === "Not Available" ? 'Submit' : (isReschedule ? 'Reschedule' : 'Schedule')}

                                    </button>
                                </div>
                            </div>
                            {isLoading == false ? <Loader isLoading={isLoading} /> : null}
                        </div>
                    </div>
                </div>
            </div>
            {!hideSchedule || !hideInterchange || !hideCandidate ? <div className="overlay"></div> : null}

            {/* INTERCHANGE STARTS HERE */}
            <div hidden={hideInterchange} className="body-bg">
                <div className="container-fluid ">
                    <div className="row justify-content-center">
                        {/*offcanvas section starts here*/}
                        <div className="hold-candidate" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                            <div className="offcanvas-header mb-4">
                                <h5 className="mb-0 bold-text font-18 hold-candidates-header-color">Move to another job</h5>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setHideInterchange(true);
                                        cancelClick('Move');
                                        setShowCandidate([]);
                                        setEmpId([]);
                                    }}
                                    className="btn-close"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="offcanvas-body">
                                <div className="col-md-12 mb-3">
                                    <label className="form-label hive-form-label" htmlFor="candidate">
                                        Candidate(s)
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    {/* <select className="form-select hive-form-select regular-text custom-textfield" onChange={onInterviewValue} id="candidate">
                                        <option value={""}>Select</option>
                                   </select> */}
                                    <Select
                                        className="dropdown"
                                        name="candidates"
                                        id="candidates"
                                        maxMenuHeight={150}
                                        placeholder="Select attendees"
                                        value={showCandidate}
                                        options={showCandidate}
                                        isMulti
                                        isDisabled
                                    // isClearable
                                    />
                                    <span style={{ color: 'red' }}>{candidatesValidation}</span>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label className="form-label hive-form-label" htmlFor="candidate">
                                        Search and pick your job posting
                                        <span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select regular-text custom-textfield"
                                        id="job_id"
                                        onChange={(e) => {
                                            setInterchangeData({
                                                ...interchangeData,
                                                ['job_id']: e.target.value.split('@')[0],
                                                ['job_title']: e.target.value.split('@')[1],
                                            });
                                        }}
                                    >
                                        <option className="">Select</option>
                                        {bindJobsTitles()}
                                    </select>
                                    <span style={{ color: 'red' }}>{interchangeErrorData.job_title}</span>
                                </div>
                                <div hidden={interchangeData.job_title == '' ? true : false}>
                                    <img src="/Images/alert.png" className=" me-2 icon-size mb-1" />
                                    <span>Any upcoming interview under the job "{jobTitle}" will be cancelled for the candidate</span>
                                </div>
                                <div className="mt-4 ms-1">
                                    <input
                                        type="checkbox"
                                        checked={interchangeData.checked}
                                        onChange={(e) => {
                                            setInterchangeData({
                                                ...interchangeData,
                                                ['checked']: e.target.checked,
                                            });
                                        }}
                                        className="form-check-input mt-0 recruitemt-input-checkbox"
                                    />{' '}
                                    <span className="ps-2 font-16">Notify Candidate</span>
                                </div>
                                <div className="col-md-12 d-flex justify-content-end" style={{ marginTop: '460px' }}>
                                    <button
                                        className="btn hive-btn-secondary me-2"
                                        onClick={() => {
                                            setHideInterchange(true);
                                            cancelClick('Move');
                                            setShowCandidate([]);
                                            setEmpId([]);
                                            setCandidateRecords([]);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button className="btn hive-btn-primary" onClick={() => submitHold('InterChange')}>
                                        Move
                                    </button>
                                </div>
                            </div>
                            {/*offcanvas body ends here*/}
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </div>
                </div>
            </div>
            {/* INTERCHANGE ENDS HERE*/}
        </div>
    )
}